{
  "absences.actions.add": "+ Afwezigheid",
  "absences.delete.confirm": "Deze afwezigheid echt verwijderen?",
  "absences.empty": "Deze organisatie heeft geen lopende dienstverbanden.",
  "absences.errors.loadFailed": "De afwezigheidskalender kon niet worden geladen.",
  "absences.form.add": "Toevoegen",
  "absences.form.choosePerson": "Kies een persoon …",
  "absences.form.close": "Sluiten",
  "absences.form.createTitle": "Nieuwe afwezigheid",
  "absences.form.editTitle": "Afwezigheid bewerken",
  "absences.form.fields.dateFrom": "Van",
  "absences.form.fields.dateTo": "Tot en met",
  "absences.form.fields.note": "Notitie",
  "absences.form.fields.person": "Persoon",
  "absences.form.fields.type": "Soort",
  "absences.form.generated": "Deze afwezigheid is door het regelwerk geschreven op basis van de klokkingen. Ze kan hier niet worden gewijzigd — de volgende verwerking zou de wijziging overschrijven.",
  "absences.form.problems.isGenerated": "Deze afwezigheid is door het regelwerk geschreven en kan niet met de hand worden gewijzigd.",
  "absences.form.problems.overlaps": "Deze persoon heeft in deze periode al een afwezigheid.",
  "absences.form.problems.overlapsGenerated": "Op deze dagen staat al een afwezigheid die het regelwerk op basis van de klokkingen heeft geschreven.",
  "absences.form.problems.saveFailed": "De afwezigheid kon niet worden opgeslagen.",
  "absences.form.saving": "Opslaan …",
  "absences.form.validation.dateFromRequired": "Vul de eerste dag in.",
  "absences.form.validation.dateToRequired": "Vul de laatste dag in.",
  "absences.form.validation.noteMaxLength": "De notitie mag hoogstens 500 tekens lang zijn.",
  "absences.form.validation.personRequired": "Kies een persoon.",
  "absences.form.validation.rangeReversed": "„Tot en met” mag niet vóór „Van” liggen.",
  "absences.form.viewTitle": "Afwezigheid",
  "absences.generated": "door het regelwerk geschreven op basis van de klokkingen",
  "absences.hint": "Klik op een dag in een rij om daar een afwezigheid in te voeren, klik op een balk om hem te openen. Ctrl + muiswiel zoomt.",
  "absences.navigation.goTo": "Ga naar datum",
  "absences.navigation.today": "Vandaag",
  "access.permission.employment.admin": "Dienstverbanden beheren",
  "access.permission.employment.admin.description": "Dienstverbanden, tijdregistratie en tijdrekeningen van de leesbare eenheden bewerken en inzien.",
  "access.permission.group.employment": "Dienstverband",
  "access.permission.group.skill": "Vaardigheden",
  "access.permission.skill.admin": "Vaardigheden beheren",
  "access.permission.skill.admin.description": "De catalogus van vaardigheden aanmaken, wijzigen en verwijderen.",
  "auth.callback.backToSignIn": "Terug naar inloggen",
  "auth.callback.errors.authFailed": "Authenticatie mislukt. Probeer het opnieuw.",
  "auth.callback.errors.exchangeFailed": "Uitwisseling mislukt ({{status}}).",
  "auth.callback.errors.missingCode": "Autorisatiecode ontbreekt.",
  "auth.callback.errors.serverNotConfirmed": "Server heeft authenticatie niet bevestigd.",
  "auth.callback.errors.sessionAfterSignIn": "Sessie kon na aanmelding niet worden opgezet.",
  "auth.callback.errors.sessionFailed": "Sessie kon niet worden opgezet. Log opnieuw in.",
  "auth.callback.exchanging": "Autorisatiecode wordt uitgewisseld…",
  "auth.callback.subtitle": "Even geduld terwijl we je account koppelen.",
  "auth.callback.success": "Gelukt. Doorverwijzen…",
  "auth.callback.title": "Aanmelding voltooien",
  "auth.forgotPassword.errors.invalidToken": "This reset link is invalid or expired.",
  "auth.forgotPassword.errors.passwordRequirements": "Your new password does not meet the requirements.",
  "auth.forgotPassword.errors.requestFailed": "Could not send reset email. Please try again.",
  "auth.forgotPassword.errors.resetFailed": "Het wachtwoord kon niet opnieuw worden ingesteld. Probeer het opnieuw.",
  "auth.forgotPassword.request.form.emailLabel": "Email",
  "auth.forgotPassword.request.form.emailPlaceholder": "you@company.com",
  "auth.forgotPassword.request.sending": "Sending…",
  "auth.forgotPassword.request.signInPrompt": "Remember your password?",
  "auth.forgotPassword.request.submit": "Send reset link",
  "auth.forgotPassword.request.subtitle": "We will email you a link to choose a new password.",
  "auth.forgotPassword.request.title": "Reset your password",
  "auth.forgotPassword.reset.form.confirmPasswordLabel": "Confirm password",
  "auth.forgotPassword.reset.form.confirmPasswordPlaceholder": "Confirm password",
  "auth.forgotPassword.reset.form.emailLabel": "Email",
  "auth.forgotPassword.reset.form.newPasswordLabel": "New password",
  "auth.forgotPassword.reset.form.newPasswordPlaceholder": "New password",
  "auth.forgotPassword.reset.signInPrompt": "Done?",
  "auth.forgotPassword.reset.submit": "Update password",
  "auth.forgotPassword.reset.submitting": "Updating…",
  "auth.forgotPassword.reset.subtitle": "Enter and confirm your new password.",
  "auth.forgotPassword.reset.title": "Choose a new password",
  "auth.forgotPassword.signInLink": "Sign in",
  "auth.forgotPassword.success.emailSent": "If an account exists, we sent a reset link to your email.",
  "auth.forgotPassword.success.passwordUpdated": "Password updated. Redirecting to sign in…",
  "auth.forgotPassword.validation.confirmPasswordRequired": "Please confirm your password",
  "auth.forgotPassword.validation.passwordMinLength": "Password must be at least 8 characters",
  "auth.forgotPassword.validation.passwordMismatch": "Passwords do not match",
  "auth.forgotPassword.validation.passwordRequired": "Password is required",
  "auth.login.credentials.invalid": "Invalid email or password.",
  "auth.login.credentials.unexpectedError": "Something went wrong. Please try again.",
  "auth.login.error.title": "Sign-in failed",
  "auth.login.errors.Callback": "There was a problem with the callback.",
  "auth.login.errors.CredentialsSignin": "Sign in failed. Check the details you provided are correct.",
  "auth.login.errors.default": "Authentication failed. Please try again.",
  "auth.login.errors.EmailCreateAccount": "Could not create account.",
  "auth.login.errors.emailNotVerified": "Verify your email before signing in. Check your inbox for the confirmation link.",
  "auth.login.errors.EmailSignin": "Check your email for the sign in link.",
  "auth.login.errors.invite_required": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.login.errors.inviteRequired": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.login.errors.OAuthAccountNotLinked": "Account not linked. Please sign in with the same account you used originally.",
  "auth.login.errors.OAuthCallback": "Sign-in with your provider failed. Please try again.",
  "auth.login.errors.OAuthCreateAccount": "Could not create account.",
  "auth.login.errors.OAuthSignin": "There was a problem signing you in via OAuth.",
  "auth.login.errors.pending_approval": "Your account was created but is not active yet. An administrator must approve your access before you can sign in.",
  "auth.login.errors.pendingApproval": "Your account was created but is not active yet. An administrator must approve your access before you can sign in.",
  "auth.login.errors.Signin": "There was a problem signing you in.",
  "auth.login.forgotPassword": "Forgot password?",
  "auth.login.form.emailLabel": "Email",
  "auth.login.form.emailPlaceholder": "you@company.com",
  "auth.login.form.passwordLabel": "Password",
  "auth.login.form.passwordPlaceholder": "••••••••",
  "auth.login.noMethodsConfigured": "No sign-in methods are configured.",
  "auth.login.oauth.continueWith": "Or continue with",
  "auth.login.oauth.custom": "Sign in",
  "auth.login.oauth.discord": "Discord",
  "auth.login.oauth.google": "Google",
  "auth.login.oauth.microsoft": "Microsoft",
  "auth.login.pageSubtitle": "Gebruik je e-mail of een gekoppeld account om door te gaan.",
  "auth.login.pageTitle": "Inloggen",
  "auth.login.pendingApproval.title": "Account pending activation",
  "auth.login.rateLimit.message": "Try again in {{seconds}} seconds.",
  "auth.login.rateLimit.title": "Too many attempts",
  "auth.login.rememberMe": "Remember me",
  "auth.login.signIn": "Sign in",
  "auth.login.signingIn": "Signing in…",
  "auth.login.signUp.link": "Create an account",
  "auth.login.signUp.prompt": "New here?",
  "auth.login.validation.passwordMinLength": "Password must be at least 6 characters",
  "auth.login.validation.passwordRequired": "Password is required",
  "auth.logout": "Uitloggen",
  "auth.password.errors.notAvailable": "Password change is not available.",
  "auth.register.createAccount": "Create account",
  "auth.register.creatingAccount": "Creating account…",
  "auth.register.errors.emailAlreadyExists": "An account with this email already exists.",
  "auth.register.errors.failedGeneric": "Registration failed.",
  "auth.register.errors.failedRetry": "Registration failed. Please try again.",
  "auth.register.errors.fillRequired": "Please fill in all required fields.",
  "auth.register.errors.inviteRequired": "You need an invitation to sign up. Ask an administrator of your organization to send you an invite link.",
  "auth.register.errors.notAvailable": "Registration is not available.",
  "auth.register.form.emailLabel": "Email",
  "auth.register.form.emailPlaceholder": "you@company.com",
  "auth.register.form.nameLabel": "Full name",
  "auth.register.form.namePlaceholder": "Jane Doe",
  "auth.register.form.passwordLabel": "Password",
  "auth.register.form.passwordPlaceholder": "Create a strong password",
  "auth.register.passwordHint": "At least 8 characters with uppercase, lowercase, a number, and a symbol.",
  "auth.register.passwordUnavailable.lead": "Registration is not available.",
  "auth.register.passwordUnavailable.signInLink": "Sign in",
  "auth.register.signIn.link": "Sign in",
  "auth.register.signIn.prompt": "Already have an account?",
  "auth.register.subtitle": "Get started with Workforce in a few steps.",
  "auth.register.title": "Create your account",
  "auth.register.validation.nameMaxLength": "Name is too long",
  "auth.register.validation.nameRequired": "Name is required",
  "auth.register.validation.passwordMaxLength": "Password is too long",
  "auth.register.validation.passwordMinLength": "Password must be at least 8 characters",
  "auth.register.validation.passwordPattern": "Password does not meet complexity requirements",
  "auth.register.validation.passwordRequired": "Password is required",
  "auth.resendVerification.failed": "We could not send a new verification email. Please try again.",
  "auth.verifyEmail.failed": "We could not verify your email address. The link may have expired.",
  "common.actions.cancel": "Cancel",
  "common.actions.delete": "Delete",
  "common.actions.edit": "Edit",
  "common.actions.reset": "Reset",
  "common.actions.save": "Save",
  "common.form.optional": "optional",
  "common.form.validation.companyMaxLength": "Company must be 255 characters or less",
  "common.form.validation.emailInvalid": "Enter a valid email address",
  "common.form.validation.emailMaxLength": "Email is too long",
  "common.form.validation.emailRequired": "Email is required",
  "common.form.validation.firstNameMaxLength100": "First name must be 100 characters or less",
  "common.form.validation.firstNameRequired": "First name is required",
  "common.form.validation.lastNameMaxLength100": "Last name must be 100 characters or less",
  "common.form.validation.lastNameRequired": "Last name is required",
  "common.form.validation.maxLength1000": "Must be 1000 characters or less",
  "common.form.validation.nameMaxLength": "Name is too long",
  "common.form.validation.nameRequired": "Name is required",
  "common.form.validation.phoneMaxLength": "Phone must be 30 characters or less",
  "common.form.validation.titleMaxLength10": "Title must be 10 characters or less",
  "common.form.validation.typeRequired": "Type is required",
  "common.loading": "Loading…",
  "common.messages.confirm": "Are you sure?",
  "common.messages.deleteConfirm": "Are you sure you want to delete this item?",
  "common.messages.error": "An error occurred",
  "common.messages.success": "Operation completed successfully",
  "common.noMatches": "Geen resultaten",
  "contacts.actions.create": "Create contact",
  "contacts.delete.description": "This action cannot be undone.",
  "contacts.details.contactInfo": "Contact Information",
  "contacts.details.fields.company": "Company",
  "contacts.details.fields.createdAt": "Created At",
  "contacts.details.fields.updatedAt": "Updated At",
  "contacts.details.professionalInfo": "Professional Information",
  "contacts.details.tags": "Tags",
  "contacts.errors.personAlreadyExists": "A contact with this email already exists.",
  "contacts.form.createTitle": "Create contact",
  "contacts.form.editTitle": "Edit contact",
  "contacts.form.fields.additionalEmail": "Additional Email",
  "contacts.form.fields.email": "Email",
  "contacts.form.fields.firstName": "First Name",
  "contacts.form.fields.lastName": "Last Name",
  "contacts.form.fields.phone": "Phone",
  "contacts.form.fields.tags": "Tags",
  "contacts.form.fields.title": "Title",
  "contacts.form.fields.type": "Type",
  "contacts.form.help.tags": "Select one or more tags to classify this contact.",
  "contacts.form.placeholders.additionalEmail": "Enter additional email (optional)",
  "contacts.form.placeholders.email": "Enter email address",
  "contacts.form.placeholders.firstName": "Enter first name",
  "contacts.form.placeholders.lastName": "Enter last name",
  "contacts.form.placeholders.phone": "Enter phone number",
  "contacts.form.placeholders.title": "Select title",
  "contacts.form.sections.contact": "Contact details",
  "contacts.form.sections.name": "Name",
  "contacts.tags.host": "Host",
  "contacts.types.contractor": "Contractor",
  "contacts.types.employee": "Employee",
  "contacts.types.guest": "Guest",
  "contacts.types.resident": "Resident",
  "contacts.types.visitor": "Visitor",
  "costCenter.actions.create": "Kostenplaats aanmaken",
  "costCenter.actions.hide": "Hier verbergen",
  "costCenter.actions.override": "Hier overschrijven",
  "costCenter.actions.restore": "Lokale versie verwijderen (weer erven)",
  "costCenter.delete.confirm": "Wilt u deze kostenplaats echt verwijderen?",
  "costCenter.errors.loadFailed": "Kostenplaatsen konden niet worden geladen.",
  "costCenter.form.createTitle": "Nieuwe kostenplaats",
  "costCenter.form.editTitle": "Kostenplaats bewerken",
  "costCenter.form.fields.department": "Gebied (optioneel)",
  "costCenter.form.fields.isInactive": "Momenteel ongeldig",
  "costCenter.form.fields.name": "Omschrijving",
  "costCenter.form.fields.number": "Kostenplaatsnummer",
  "costCenter.form.fields.validFrom": "Geldig vanaf",
  "costCenter.form.fields.validTo": "Geldig tot",
  "costCenter.form.overrideTitle": "Kostenplaats overschrijven",
  "costCenter.form.saving": "Opslaan …",
  "costCenter.form.validation.departmentMaxLength": "Gebied is te lang.",
  "costCenter.form.validation.nameMaxLength": "Omschrijving is te lang.",
  "costCenter.form.validation.nameRequired": "Omschrijving is verplicht.",
  "costCenter.form.validation.numberMaxLength": "Kostenplaatsnummer is te lang.",
  "costCenter.form.validation.numberRequired": "Kostenplaatsnummer is verplicht.",
  "costCenter.form.validation.validFromRequired": "Geldig vanaf is verplicht.",
  "costCenter.list.empty": "Nog geen kostenplaatsen aanwezig.",
  "costCenter.list.inactive": "ongeldig",
  "costCenter.list.inheritedFrom": "geërfd van {{unit}}",
  "costCenter.list.overridden": "overschreven",
  "dashboard.noPerson.description": "Your account is not linked to a person in any organization yet, so there is nothing to show here. Ask an administrator to send you an invite link.",
  "dashboard.noPerson.title": "No organization assigned",
  "dashboard.persons.grid.description": "Browse and manage persons in the selected organization.",
  "dashboard.scaffold.dummyDescription": "Placeholderpagina",
  "dashboard.scaffold.gridPlaceholder": "ag-grid placeholder",
  "dashboard.time.accounts.balanceDummy": "Dummygegevens voor maandsaldo",
  "dashboard.time.accounts.chartPlaceholder": "ag-chart placeholder — {{count}} datapunten",
  "dashboard.time.accounts.chartPlaceholderSimple": "ag-chart placeholder",
  "dashboard.time.accounts.historyTitle": "Verloop tijdrekening",
  "dashboard.time.accounts.hoursDummy": "Dummygegevens voor gewerkte uren",
  "dashboard.time.accounts.rangeLabel": "Periode",
  "dsl.editor.activate": "Activeren",
  "dsl.editor.activating": "Activeren…",
  "dsl.editor.active": "Actief",
  "dsl.editor.compileError.MULTIPLE_PIPELINES": "Er is meer dan één rule-configuration-blok. Houd er precies één en verplaats alle regels daarheen.",
  "dsl.editor.compileError.PIPELINE_MISSING": "Er is geen rule-configuration-blok, dus er kan niets worden uitgevoerd. Voeg er een toe uit de categorie Structure.",
  "dsl.editor.compileError.title": "Opgeslagen, maar geen uitvoerbare regels",
  "dsl.editor.context.appliesTo": "Geldt voor de tijdmodellen:",
  "dsl.editor.context.appliesToAll": "Geldt voor alle tijdmodellen van deze eenheid.",
  "dsl.editor.context.appliesToAllHint": "Fase 1 noemt geen tijdmodel. Een regelset van dezelfde eenheid die er één expliciet noemt, gaat voor dat tijdmodel voor.",
  "dsl.editor.context.governsNobody": "Deze regelset geldt voor niemand.",
  "dsl.editor.context.governsNobodyHint": "Fase 1 is leeg, dus geen enkel contract volgt deze regelset. Voeg “applies to time model” toe en sla op — het geldt om te beginnen voor alle tijdmodellen.",
  "dsl.editor.context.shadows": "Vervangt de regelset met dezelfde code van {{unit}}.",
  "dsl.editor.draft": "Concept — draait nog niet",
  "dsl.editor.draftRunning": "Concept — versie {{running}} draait",
  "dsl.editor.loadFailed": "Het regelwerk kon niet worden geladen.",
  "dsl.editor.masterDataIssue.CHANGED_ON_LOAD": "opgeslagen, maar bij het laden gewijzigd – controleer het blok en sla opnieuw op",
  "dsl.editor.masterDataIssue.FIELD_OF_OTHER_ENTITY": "het veld hoort niet bij deze entiteit",
  "dsl.editor.masterDataIssue.NO_PREVIOUS_DAY": "voor dit veld bestaat geen vorige dag",
  "dsl.editor.masterDataIssue.UNKNOWN_DAY": "onbekende dag",
  "dsl.editor.masterDataIssue.UNKNOWN_ENTITY": "onbekende entiteit",
  "dsl.editor.masterDataIssue.UNKNOWN_FIELD": "onbekend veld",
  "dsl.editor.masterDataIssues": "Deze versie leest stamgegevens die niet kunnen worden gelezen zoals ze zijn opgeslagen. Activeren is pas mogelijk na correctie:",
  "dsl.editor.noVersionYet": "Nog niet opgeslagen",
  "dsl.editor.referenceIssues": "Dit regelwerk verwijst naar stamgegevens die in deze organisatie-eenheid niet meer bestaan:",
  "dsl.editor.referenceKind.account": "Rekening",
  "dsl.editor.referenceKind.bookingType": "Boekingssoort",
  "dsl.editor.referenceKind.timeType": "Tijdsoort",
  "dsl.editor.save": "Regelwerk opslaan",
  "dsl.editor.saveConflict.allTimeModels": "De regelset „{{ruleSet}}” ({{ruleSetCode}}) van deze organisatie-eenheid geldt al voor alle tijdmodellen. Dat kan maar één regelset per eenheid — noem hier een specifiek tijdmodel en sla opnieuw op.",
  "dsl.editor.saveConflict.timeModel": "Het tijdmodel {{workSchedule}} is al toegewezen aan de regelset „{{ruleSet}}” ({{ruleSetCode}}) van deze organisatie-eenheid. Een tijdmodel kan maar bij één regelset per eenheid horen — verwijder het hier of daar uit de toewijzing en sla opnieuw op.",
  "dsl.editor.saveConflict.title": "Niet opgeslagen",
  "dsl.editor.saving": "Opslaan …",
  "dsl.editor.title": "Regelwerk",
  "dsl.editor.version": "Versie {{version}}",
  "dsl.masterData.fields.entryDate": "Datum indiensttreding",
  "dsl.masterData.fields.exitDate": "Datum uitdiensttreding",
  "dsl.masterData.fields.sicknessReferenceDate": "Begin ziektejaar",
  "dsl.masterData.fields.sicknessServiceDurationDays": "Ziekte: telbare diensttijd (dagen)",
  "dsl.masterData.fields.sicknessServiceStartDate": "Ziekte: begin van de meetellende diensttijd",
  "dsl.masterData.fields.vacationReferenceDate": "Begin verlofjaar",
  "dsl.masterData.fields.vacationServiceDurationDays": "Verlof: telbare diensttijd (dagen)",
  "dsl.masterData.fields.vacationServiceStartDate": "Verlof: begin van de meetellende diensttijd",
  "dsl.masterData.fields.vacationWaitingPeriodMonths": "Wachttijd tot het eerste verlofrecht (maanden)",
  "dsl.masterData.fields.vacationYearType": "Verlofjaar",
  "dsl.masterData.fields.weeklyTargetMinutes": "Weeknorm uit het tijdmodel (minuten)",
  "dsl.masterData.fields.workDaysPerWeek": "Werkdagen per week",
  "dsl.ruleSets.actions.create": "Nieuwe regelset",
  "dsl.ruleSets.create.title": "Nieuwe regelset",
  "dsl.ruleSets.delete.confirm": "Deze regelset en al haar versies verwijderen?",
  "dsl.ruleSets.empty": "Deze eenheid heeft geen eigen regelset. Die van de dichtstbijzijnde bovenliggende eenheid geldt.",
  "dsl.ruleSets.fields.code": "Code",
  "dsl.ruleSets.fields.codeHint": "De sleutel waarop de overerving werkt. Hoofdletters, geen spaties — later niet meer te wijzigen.",
  "dsl.ruleSets.fields.name": "Naam",
  "dsl.ruleSets.loadFailed": "De regelsets konden niet worden geladen.",
  "dsl.ruleSets.neverSaved": "nog niet opgeslagen",
  "dsl.ruleSets.problems.codePattern": "De code mag alleen A–Z, 0–9 en underscores bevatten.",
  "dsl.ruleSets.problems.codeRequired": "Voer een code in.",
  "dsl.ruleSets.problems.codeTaken": "Deze eenheid heeft al een regelset met deze code.",
  "dsl.ruleSets.problems.nameRequired": "Voer een naam in.",
  "dsl.ruleSets.validation.codePattern": "De code mag alleen A–Z, 0–9 en underscores bevatten.",
  "dsl.status.edit": "Regelwerk bewerken",
  "dsl.status.lastChanged": "Laatst gewijzigd",
  "dsl.status.loadFailed": "De status van het regelwerk kon niet worden geladen.",
  "dsl.status.noRuleSet": "Voor deze organisatie-eenheid is nog geen regelwerk gedefinieerd.",
  "dsl.status.version": "Versie {{version}}",
  "employment.entity.absence": "Afwezigheid",
  "employment.entity.group.time": "Tijd",
  "employment.entity.timeAccount": "Tijdrekening",
  "employmentPicker.allUnits": "Alle eenheden",
  "employmentPicker.empty": "Geen dienstverband gevonden",
  "employmentPicker.loading": "Zoeken …",
  "employmentPicker.more": "Meer resultaten – verfijn de zoekopdracht",
  "employmentPicker.noUnit": "Geen eenheid gevonden",
  "employmentPicker.personnelNumber": "Pers.nr. {{number}}",
  "employmentPicker.placeholder": "Naam, personeels- of contractnummer",
  "employmentPicker.unitPlaceholder": "Eenheid zoeken",
  "employments.create": "Nieuw dienstverband",
  "employments.directory.actions": "Acties",
  "employments.directory.back": "Terug naar de lijst",
  "employments.directory.chooseCompany": "Bedrijf kiezen",
  "employments.directory.company": "Bedrijf",
  "employments.directory.empty": "Deze mandant heeft nog geen dienstverbanden.",
  "employments.directory.more": "Meer laden",
  "employments.directory.noCompany": "Deze mandant heeft geen bedrijf waarop een dienstverband kan worden aangemaakt.",
  "employments.directory.personnelNumber": "Personeelsnr.",
  "employments.directory.search": "Zoeken",
  "employments.directory.state": "Status",
  "employments.directory.subtitle": "Alle dienstverbanden van de mandant – op naam, personeels- of contractnummer.",
  "employments.empty": "Deze eenheid heeft nog geen dienstverbanden.",
  "employments.errors.loadFailed": "De dienstverbanden konden niet worden geladen.",
  "employments.fields.employmentNumber": "Nummer",
  "employments.fields.employmentRelationship": "Werknemersgroep",
  "employments.fields.employmentType": "Contractsoort",
  "employments.fields.entryDate": "Indiensttreding",
  "employments.fields.exitDate": "Uitdiensttreding",
  "employments.fields.payGrade": "Salarisgroep",
  "employments.fields.payGradeLevel": "Salarisniveau",
  "employments.fields.payScale": "Cao",
  "employments.fields.person": "Persoon",
  "employments.fields.sicknessCreditedFrom": "Ziekte: diensttijd telt vanaf",
  "employments.fields.sicknessCreditedMonths": "Ziekte: meegetelde maanden",
  "employments.fields.sicknessReferenceDate": "Begin ziektejaar",
  "employments.fields.vacationCreditedFrom": "Verlof: diensttijd telt vanaf",
  "employments.fields.vacationCreditedMonths": "Verlof: meegetelde maanden",
  "employments.fields.vacationReferenceDate": "Begin verlofjaar",
  "employments.fields.validFrom": "Geldig vanaf",
  "employments.fields.validTo": "Geldig tot",
  "employments.fields.weeklyHours": "Weekuren",
  "employments.fields.workSchedule": "Tijdmodel",
  "employments.form.choose": "Maak een keuze…",
  "employments.form.choosePerson": "Kies een persoon…",
  "employments.form.chooseWorkSchedule": "Kies een tijdmodel…",
  "employments.form.createTitle": "Nieuw dienstverband",
  "employments.form.creditedHint": "Geef voordienst per doel op als datum óf als maanden, niet beide. Leeg betekent niets meegeteld.",
  "employments.form.editTitle": "Dienstverband bewerken",
  "employments.form.none": "— geen —",
  "employments.form.noWorkSchedules": "Deze organisatie-eenheid heeft nog geen tijdmodellen. Maak er een aan bij Tijdbeheer → Tijdmodellen.",
  "employments.form.personFixed": "Persoon en organisatie-eenheid kunnen bij een bestaand dienstverband niet worden gewijzigd.",
  "employments.form.problems.employmentNumber": "Voer een dienstverbandnummer in.",
  "employments.form.problems.employmentType": "Kies een contractsoort.",
  "employments.form.problems.entryDate": "Voer een datum van indiensttreding in.",
  "employments.form.problems.exitDateBeforeEntry": "De uitdiensttreding ligt vóór de indiensttreding.",
  "employments.form.problems.notAnEmployer": "Dienstverbanden horen bij een bedrijf. Deze organisatie-eenheid is er geen — kies een bedrijf in de lijst.",
  "employments.form.problems.organizationUnitId": "Er is geen organisatie-eenheid meegegeven. Begin vanuit de lijst.",
  "employments.form.problems.personId": "Kies een persoon.",
  "employments.form.problems.saveFailed": "Opslaan mislukt. Probeer het opnieuw.",
  "employments.form.problems.validFrom": "Voer het begin van de geldigheid in.",
  "employments.form.problems.validToBeforeValidFrom": "De geldigheid eindigt voordat ze begint.",
  "employments.form.problems.weeklyHours": "Weekuren moeten een getal zijn, bijvoorbeeld 38,5.",
  "employments.form.problems.workScheduleId": "Kies een tijdmodel. Zonder dit plant niets de dagen van deze persoon.",
  "employments.list.noMatch": "Geen dienstverband komt overeen met de zoekopdracht.",
  "employments.list.search": "Zoeken op nummer of naam",
  "employments.onlyOnCompany": "Dienstverbanden worden op een bedrijf aangemaakt. Kies hierboven een bedrijf.",
  "employments.organizationUnit": "Organisatie-eenheid",
  "employments.person.account": "Tijdrekening",
  "employments.person.none": "Deze persoon heeft geen dienstverband dat u mag zien.",
  "employments.person.open": "Openen",
  "employments.person.tracking": "Tijdregistratie",
  "employments.state.ACTIVE": "actief",
  "employments.state.ENDED": "beëindigd",
  "employments.state.UPCOMING": "toekomstig",
  "nav.chart.month.apr": "Apr",
  "nav.chart.month.aug": "Aug",
  "nav.chart.month.dec": "Dec",
  "nav.chart.month.feb": "Feb",
  "nav.chart.month.jan": "Jan",
  "nav.chart.month.jul": "Jul",
  "nav.chart.month.jun": "Jun",
  "nav.chart.month.mar": "Mrt",
  "nav.chart.month.may": "Mei",
  "nav.chart.month.nov": "Nov",
  "nav.chart.month.oct": "Okt",
  "nav.chart.month.sep": "Sep",
  "nav.chart.range.month": "Uren deze maand",
  "nav.chart.range.week": "Uren deze week",
  "nav.chart.range.year": "Uren dit jaar",
  "nav.chart.week.kw1": "Wk 1",
  "nav.chart.week.kw2": "Wk 2",
  "nav.chart.week.kw3": "Wk 3",
  "nav.chart.week.kw4": "Wk 4",
  "nav.chart.weekday.fri": "Vr",
  "nav.chart.weekday.mon": "Ma",
  "nav.chart.weekday.sat": "Za",
  "nav.chart.weekday.sun": "Zo",
  "nav.chart.weekday.thu": "Do",
  "nav.chart.weekday.tue": "Di",
  "nav.chart.weekday.wed": "Wo",
  "nav.dashboard.title": "Dashboard",
  "nav.mobile.close": "Sluiten",
  "nav.mobile.closeMenu": "Menu sluiten",
  "nav.mobile.mainNavigation": "Hoofdnavigatie",
  "nav.mobile.menu": "Menu",
  "nav.mobile.more": "Meer",
  "nav.mobile.moreSubtitle": "Extra onderdelen",
  "nav.primary.home": "Home",
  "nav.primary.orgChart": "Organigram",
  "nav.primary.payScale": "Cao",
  "nav.primary.payScale.short": "Cao",
  "nav.primary.persons": "Personen",
  "nav.primary.plan": "Plan",
  "nav.primary.settings": "Instellingen",
  "nav.primary.time": "Tijd",
  "nav.search.empty": "Geen passend menu-item",
  "nav.search.keywords.org-chart": "organisatie-eenheid, werkrooster, dagprogramma, rekeningdefinitie, boekingssoort, tijdsoort, feestdag, regelwerk, kostenplaats, functie",
  "nav.search.keywords.pay-scale.grades": "salaris, salarisgroep",
  "nav.search.keywords.pay-scale.scales": "cao, tarief",
  "nav.search.keywords.persons.employments": "contract, dienstverband",
  "nav.search.keywords.persons.grid": "medewerker, persoon zoeken",
  "nav.search.keywords.plan.schedule": "dienst, rooster",
  "nav.search.keywords.settings.accounts": "gebruikersaccount, login, uitnodiging",
  "nav.search.keywords.settings.organizations": "mandant, organisatie",
  "nav.search.keywords.settings.roles": "rechten, machtigingen, rol",
  "nav.search.keywords.time.absences": "vakantie, ziekte, kalender",
  "nav.search.keywords.time.accounts": "saldo, rekening, correctieboeking, glijtijd, journaal",
  "nav.search.keywords.time.runs": "verwerking, run, herberekening, periodeafsluiting",
  "nav.search.keywords.time.runs.log": "protocol, fouten, run",
  "nav.search.keywords.time.tracking": "stempel, boeking registreren, komen, gaan, interval",
  "nav.search.placeholder": "Menu doorzoeken …",
  "nav.secondary.payScale.grades": "Salarisgroepen",
  "nav.secondary.payScale.levels": "Salarisniveaus",
  "nav.secondary.payScale.scales": "Cao's",
  "nav.secondary.persons.employments": "Dienstverbanden",
  "nav.secondary.persons.grid": "Personenlijst",
  "nav.secondary.persons.profile": "Profiel",
  "nav.secondary.persons.settings": "Instellingen",
  "nav.secondary.persons.skills": "Vaardigheden",
  "nav.secondary.plan.overview": "Overzicht",
  "nav.secondary.plan.schedule": "Rooster",
  "nav.secondary.settings.accounts": "Gebruikers",
  "nav.secondary.settings.general": "Instellingen",
  "nav.secondary.settings.organizations": "Organisaties",
  "nav.secondary.settings.profile": "Profiel",
  "nav.secondary.settings.roles": "Rollen",
  "nav.secondary.settings.textCatalog": "Tekstcatalogus",
  "nav.secondary.time.absences": "Afwezigheden",
  "nav.secondary.time.accounts": "Tijdrekeningen",
  "nav.secondary.time.runs": "Verwerking starten",
  "nav.secondary.time.runsLog": "Verwerkingslog",
  "nav.secondary.time.tracking": "Tijdregistratie",
  "nav.topbar.apps": "Apps",
  "nav.topbar.brand": "Workforce",
  "nav.topbar.home": "Workforce home",
  "nav.topbar.language": "Taal",
  "nav.topbar.openMenu": "Menu openen",
  "organigram.delete.confirm": "Verwijderen",
  "organigram.delete.messageAssignment": "Wilt u deze persoon echt uit de functie verwijderen?",
  "organigram.delete.messageOe": "Wilt u deze organisatie-eenheid echt verwijderen? Dit kan niet ongedaan worden gemaakt.",
  "organigram.delete.messagePosition": "Wilt u deze functie echt verwijderen? Dit kan niet ongedaan worden gemaakt.",
  "organigram.delete.messageStation": "Wilt u dit station echt verwijderen? Dit kan niet ongedaan worden gemaakt.",
  "organigram.delete.title": "Verwijderen bevestigen",
  "organigram.empty": "Geen organisatiestructuur beschikbaar.",
  "organigram.errors.childrenNotAllowed": "De eenheden hieronder zouden niet onder het nieuwe soort mogen staan. Verplaats ze eerst en wijzig daarna het soort.",
  "organigram.errors.companyEmploys": "Aan deze eenheid hangen dienstverbanden; ze moet een bedrijf blijven.",
  "organigram.errors.deleteFailed": "Verwijderen mislukt.",
  "organigram.errors.loadFailed": "Het organigram kon niet worden geladen.",
  "organigram.errors.moveFailed": "Verplaatsen mislukt.",
  "organigram.errors.parentTakesNoChildren": "Onder deze eenheid staan geen andere eenheden.",
  "organigram.errors.positionsNotAllowed": "Aan deze eenheid hangen functies, die het nieuwe soort niet draagt.",
  "organigram.errors.rootTakesOne": "De organisatie heeft haar bedrijf al. Verdere eenheden komen daaronder.",
  "organigram.errors.saveFailed": "Opslaan mislukt.",
  "organigram.errors.stationsNotAllowed": "Aan deze eenheid hangen stations, die het nieuwe soort niet draagt.",
  "organigram.errors.typeNotAllowedUnderParent": "Dit soort eenheid mag daar niet staan. De opbouw is: wortel → bedrijf → profitcenter → afdeling.",
  "organigram.node.add": "Toevoegen",
  "organigram.node.addOe": "Organisatie-eenheid",
  "organigram.node.addOeTooltip": "Organisatie-eenheid toevoegen",
  "organigram.node.addPerson": "Persoon toewijzen",
  "organigram.node.addPosition": "Functie",
  "organigram.node.addStation": "Station",
  "organigram.node.deleteOe": "Organisatie-eenheid verwijderen",
  "organigram.node.deletePosition": "Functie verwijderen",
  "organigram.node.deleteStation": "Station verwijderen",
  "organigram.node.editPosition": "Functie bewerken",
  "organigram.node.editStation": "Station bewerken",
  "organigram.node.locked": "Vergrendeld (juridische entiteit)",
  "organigram.node.settings": "Configuratie",
  "organigram.node.viewPermissions": "View permissions",
  "organigram.oe.positionOne": "functie",
  "organigram.oe.positionOther": "functies",
  "organigram.oe.stationOne": "station",
  "organigram.oe.stationOther": "stations",
  "organigram.oeType.company": "Bedrijf",
  "organigram.oeType.department": "Afdeling",
  "organigram.oeType.organization": "Organisatie (hoofd)",
  "organigram.oeType.profitCenter": "Profitcenter",
  "organigram.panel.actions.cancel": "Annuleren",
  "organigram.panel.actions.delete": "Verwijderen",
  "organigram.panel.actions.save": "Opslaan",
  "organigram.panel.actions.saving": "Opslaan …",
  "organigram.panel.errors.loadingPermissions": "Could not load permissions",
  "organigram.panel.fields.countryCode": "Land",
  "organigram.panel.fields.countryCodeNone": "Geen land",
  "organigram.panel.fields.description": "Omschrijving (optioneel)",
  "organigram.panel.fields.legalName": "Juridische naam (optioneel)",
  "organigram.panel.fields.name": "Naam",
  "organigram.panel.fields.person": "Persoon",
  "organigram.panel.fields.personPlaceholder": "Selecteer …",
  "organigram.panel.fields.primary": "Als hoofdfunctie",
  "organigram.panel.fields.responsiblePerson": "Verantwoordelijke",
  "organigram.panel.fields.responsiblePersonChosen": "Gekozen:",
  "organigram.panel.fields.responsiblePersonClear": "verwijderen",
  "organigram.panel.fields.responsiblePersonNone": "Geen persoon gevonden.",
  "organigram.panel.fields.responsiblePersonSearch": "Zoek een persoon …",
  "organigram.panel.fields.roles": "Rollen",
  "organigram.panel.fields.timezone": "Tijdzone",
  "organigram.panel.fields.timezoneHint": "Bepaalt wat een regel bedoelt met een kloktijd zoals “niet voor 08:30”.",
  "organigram.panel.fields.timezoneInherited": "Zoals bovenliggende eenheid",
  "organigram.panel.fields.type": "Type",
  "organigram.panel.fields.vacationInherited": "— van de bovenliggende eenheid —",
  "organigram.panel.fields.vacationWaitingPeriodHint": "Leeg laten om de waarde van de bovenliggende eenheid over te nemen. 0 betekent recht vanaf de eerste dag.",
  "organigram.panel.fields.vacationWaitingPeriodMonths": "Wachttijd tot het eerste recht (maanden)",
  "organigram.panel.fields.vacationYearType": "Verlofjaar",
  "organigram.panel.noPersons": "Geen personen gevonden in deze organisatie.",
  "organigram.panel.noRoles": "Geen rollen beschikbaar.",
  "organigram.panel.permissions.all": "Alles",
  "organigram.panel.removeRole": "Rol verwijderen",
  "organigram.panel.rolePlaceholder": "Rol toevoegen …",
  "organigram.panel.settings.accounts": "Rekeningen",
  "organigram.panel.settings.backToSections": "Terug naar het overzicht",
  "organigram.panel.settings.bookingTypes": "Boekingssoorten",
  "organigram.panel.settings.costCenters": "Kostenplaatsen",
  "organigram.panel.settings.dayPrograms": "Dagprogramma's",
  "organigram.panel.settings.employments": "Dienstverbanden",
  "organigram.panel.settings.groups.costAccounting": "Kostenadministratie",
  "organigram.panel.settings.groups.employment": "Dienstverbanden",
  "organigram.panel.settings.groups.hints.costAccounting": "Kostenplaatsen waarop tijd wordt geboekt",
  "organigram.panel.settings.groups.hints.employment": "Wie bij dit bedrijf in dienst is",
  "organigram.panel.settings.groups.hints.timeManagement": "Boekingssoorten, tijdsoorten, rekeningen en regels",
  "organigram.panel.settings.groups.hints.unit": "Naam, type, tijdzone en kerntijd",
  "organigram.panel.settings.groups.timeManagement": "Tijdbeheer",
  "organigram.panel.settings.hints.accounts": "Saldi zoals flexuren en overuren",
  "organigram.panel.settings.hints.bookingTypes": "Om welke redenen er geklokt kan worden",
  "organigram.panel.settings.hints.costCenters": "Op welke kostenplaatsen tijd wordt geboekt",
  "organigram.panel.settings.hints.dayPrograms": "Hoe een werkdag gepland verloopt",
  "organigram.panel.settings.hints.employments": "De contracten van de medewerkers van dit bedrijf",
  "organigram.panel.settings.hints.publicHolidays": "Welke feestdagen gelden en of ze heel of half zijn",
  "organigram.panel.settings.hints.rules": "De regels die klokkingen omzetten in saldi",
  "organigram.panel.settings.hints.timeTypes": "Hoe geregistreerde tijd wordt gewaardeerd",
  "organigram.panel.settings.hints.workSchedules": "Welk dagprogramma elke weekdag volgt",
  "organigram.panel.settings.inherited": "Deze afdeling erft haar configuratie. Die wordt beheerd op het bedrijf of de organisatie erboven.",
  "organigram.panel.settings.publicHolidays": "Feestdagen",
  "organigram.panel.settings.root": "Configuratie",
  "organigram.panel.settings.rules": "Regelwerk",
  "organigram.panel.settings.timeTypes": "Tijdsoorten",
  "organigram.panel.settings.workSchedules": "Tijdmodellen",
  "organigram.panel.title.assignPerson": "Persoon toewijzen",
  "organigram.panel.title.createOe": "Organisatie-eenheid toevoegen",
  "organigram.panel.title.createPosition": "Functie toevoegen",
  "organigram.panel.title.createStation": "Station toevoegen",
  "organigram.panel.title.editOe": "Organisatie-eenheid bewerken",
  "organigram.panel.title.editPosition": "Functie bewerken",
  "organigram.panel.title.editStation": "Station bewerken",
  "organigram.panel.title.settings": "Configuratie",
  "organigram.panel.title.viewPermissions": "Rechten van de functie",
  "organigram.panel.vacationYear.calendarYear": "Kalenderjaar",
  "organigram.panel.vacationYear.workYear": "Werkjaar",
  "organigram.panel.validation.descriptionMaxLength": "Omschrijving is te lang.",
  "organigram.panel.validation.legalNameMaxLength": "Juridische naam is te lang.",
  "organigram.panel.validation.nameMaxLength": "Naam is te lang.",
  "organigram.panel.validation.nameRequired": "Naam is verplicht.",
  "organigram.panel.validation.vacationWaitingPeriodRange": "Voer een geheel getal van 0 tot 120 in, of laat leeg om over te nemen.",
  "organigram.position.empty": "Geen invulling",
  "organigram.position.label": "Functie",
  "organigram.position.more": "Meer acties",
  "organigram.position.personOne": "persoon",
  "organigram.position.personOther": "personen",
  "organigram.position.roleOne": "rol",
  "organigram.position.roleOther": "rollen",
  "organigram.row.openPerson": "Persoon openen",
  "organigram.row.primary": "Hoofdfunctie",
  "organigram.row.removeAssignment": "Toewijzing verwijderen",
  "organigram.row.secondary": "Invulling",
  "organigram.title": "Organigram",
  "organigram.toolbar.all": "Alles",
  "organigram.toolbar.arrange": "Ordenen",
  "organigram.toolbar.arrangeHint": "Het organigram opnieuw ordenen zoals bij het laden",
  "organigram.toolbar.collapseAll": "Alles inklappen",
  "organigram.toolbar.collapsePositions": "Functies van alle eenheden verbergen",
  "organigram.toolbar.expandAll": "Functies, personen en stations uitklappen",
  "organigram.toolbar.expandPositions": "Functies van alle eenheden tonen",
  "organigram.toolbar.positions": "Functies",
  "organigram.zoom.fit": "Organigram passend maken",
  "organigram.zoom.in": "Inzoomen",
  "organigram.zoom.out": "Uitzoomen",
  "organigram.zoom.reset": "Zoom terugzetten naar 100%",
  "organization.entity.group.people": "People",
  "organization.entity.group.structure": "Structure",
  "organization.entity.organigram": "Organigram",
  "organization.entity.organizationUnit": "Organization Unit",
  "organization.entity.person": "Person",
  "organization.entity.personPosition": "Person Position",
  "organization.entity.position": "Position",
  "organization.persons.actions.addAndInvite": "Persoon toevoegen en uitnodigen",
  "organization.persons.actions.creating": "Aanmaken…",
  "organization.persons.actions.resendInvite": "Uitnodiging opnieuw verzenden",
  "organization.persons.confirmRemove": "{{name}} echt uit deze organisatie verwijderen?",
  "organization.persons.empty": "Nog geen personen in deze organisatie.",
  "organization.persons.errors.createFailed": "Persoon kon niet worden aangemaakt.",
  "organization.persons.errors.removeFailed": "Persoon kon niet worden verwijderd.",
  "organization.persons.errors.resendFailed": "Uitnodiging kon niet opnieuw worden verzonden.",
  "organization.persons.fields.email": "E-mail",
  "organization.persons.fields.firstName": "Voornaam",
  "organization.persons.fields.isOwner": "Als beheerder / eigenaar van de organisatie",
  "organization.persons.fields.lastName": "Achternaam",
  "organization.persons.inviteLink": "Link",
  "organization.persons.inviteSent": "Uitnodiging verzonden naar {{email}}.",
  "organization.persons.loading": "Personen laden…",
  "organization.persons.status.invited": " · uitgenodigd",
  "organization.persons.status.linked": " · gekoppeld",
  "organization.persons.title": "Personen",
  "payScale.grades.actions.create": "Salarisgroep aanmaken",
  "payScale.grades.actions.edit": "Bewerken",
  "payScale.grades.actions.saving": "Opslaan…",
  "payScale.grades.columns.code": "Code",
  "payScale.grades.columns.employmentRelationship": "Werknemersgroep",
  "payScale.grades.columns.name": "Naam",
  "payScale.grades.columns.payScale": "Cao",
  "payScale.grades.columns.validFrom": "Geldig vanaf",
  "payScale.grades.description": "Beheer de salarisgroepen van uw cao's.",
  "payScale.grades.details.code": "Code",
  "payScale.grades.details.employmentRelationship": "Werknemersgroep",
  "payScale.grades.details.loading": "Salarisgroep wordt geladen…",
  "payScale.grades.details.name": "Naam",
  "payScale.grades.details.payScale": "Cao",
  "payScale.grades.details.sections.info": "Salarisgroepinformatie",
  "payScale.grades.details.validFrom": "Geldig vanaf",
  "payScale.grades.details.validTo": "Geldig tot",
  "payScale.grades.form.createTitle": "Salarisgroep aanmaken",
  "payScale.grades.form.editTitle": "Salarisgroep bewerken",
  "payScale.grades.form.fields.code": "Code",
  "payScale.grades.form.fields.employmentRelationship": "Werknemersgroep",
  "payScale.grades.form.fields.name": "Naam",
  "payScale.grades.form.fields.payScale": "Cao",
  "payScale.grades.form.fields.validFrom": "Geldig vanaf",
  "payScale.grades.form.fields.validTo": "Geldig tot",
  "payScale.grades.form.loading": "Salarisgroep wordt geladen…",
  "payScale.grades.form.validation.codeMaxLength": "Code is te lang",
  "payScale.grades.form.validation.codeRequired": "Code is verplicht",
  "payScale.grades.form.validation.employmentRelationshipRequired": "Werknemersgroep is verplicht",
  "payScale.grades.form.validation.nameMaxLength": "Naam is te lang",
  "payScale.grades.form.validation.nameRequired": "Naam is verplicht",
  "payScale.grades.form.validation.payScaleRequired": "Cao is verplicht",
  "payScale.grades.form.validation.validFromRequired": "'Geldig vanaf' is verplicht",
  "payScale.grades.list.placeholderDescription": "Selecteer een salarisgroep in de tabel om de details te bekijken.",
  "payScale.grades.list.placeholderTitle": "Salarisgroepen",
  "payScale.grades.title": "Salarisgroepen",
  "payScale.levels.actions.create": "Niveau aanmaken",
  "payScale.levels.actions.edit": "Bewerken",
  "payScale.levels.actions.saving": "Opslaan…",
  "payScale.levels.advanceInfoMonths": "doorstroming na {{months}} m.",
  "payScale.levels.advanceInfoYears": "doorstroming na {{years}} j.",
  "payScale.levels.columns.amount": "Bedrag",
  "payScale.levels.columns.levelName": "Niveau",
  "payScale.levels.columns.payGrade": "Salarisgroep",
  "payScale.levels.columns.validFrom": "Geldig vanaf",
  "payScale.levels.description": "Beheer de salarisniveaus binnen elke salarisgroep.",
  "payScale.levels.details.advance": "Doorstroming",
  "payScale.levels.details.amount": "Bedrag",
  "payScale.levels.details.levelName": "Niveau",
  "payScale.levels.details.loading": "Niveau wordt geladen…",
  "payScale.levels.details.nextGrade": "Volgende groep",
  "payScale.levels.details.nextLevel": "Volgend niveau",
  "payScale.levels.details.payGrade": "Salarisgroep",
  "payScale.levels.details.sections.info": "Niveau-informatie",
  "payScale.levels.details.validFrom": "Geldig vanaf",
  "payScale.levels.details.validTo": "Geldig tot",
  "payScale.levels.form.createTitle": "Niveau aanmaken",
  "payScale.levels.form.editTitle": "Niveau bewerken",
  "payScale.levels.form.fields.advanceAfterMonths": "Doorstroming na maanden",
  "payScale.levels.form.fields.advanceAfterYears": "Doorstroming na jaren",
  "payScale.levels.form.fields.amount": "Bedrag",
  "payScale.levels.form.fields.levelName": "Niveau",
  "payScale.levels.form.fields.nextGrade": "Volgende groep",
  "payScale.levels.form.fields.nextLevel": "Volgend niveau",
  "payScale.levels.form.fields.none": "—",
  "payScale.levels.form.fields.payGrade": "Salarisgroep",
  "payScale.levels.form.fields.payScale": "Cao",
  "payScale.levels.form.fields.validFrom": "Geldig vanaf",
  "payScale.levels.form.fields.validTo": "Geldig tot",
  "payScale.levels.form.loading": "Niveau wordt geladen…",
  "payScale.levels.form.validation.amountRequired": "Bedrag is verplicht",
  "payScale.levels.form.validation.levelNameRequired": "Niveau is verplicht",
  "payScale.levels.form.validation.payGradeRequired": "Salarisgroep is verplicht",
  "payScale.levels.form.validation.validFromRequired": "'Geldig vanaf' is verplicht",
  "payScale.levels.list.placeholderDescription": "Selecteer een niveau in de tabel om de details te bekijken.",
  "payScale.levels.list.placeholderTitle": "Salarisniveaus",
  "payScale.levels.title": "Salarisniveaus",
  "permission.action.bookCorrection": "Correcties boeken",
  "permission.action.create": "Create",
  "permission.action.delete": "Delete",
  "permission.action.read": "Read",
  "permission.action.readInternal": "Interne rekeningen zien",
  "permission.action.sendInvite": "Can send invite",
  "permission.action.update": "Update",
  "permission.matrix.action": "Actie",
  "permission.matrix.entity": "Entity / Action",
  "permission.scope.all": "All",
  "permission.scope.child_oe": "Child OE",
  "permission.scope.own": "Own",
  "permission.scope.same_oe": "Same OE",
  "permission.scope.same_position": "Same Position",
  "persons.form.placeholders.city": "Enter city",
  "persons.form.placeholders.country": "Enter country",
  "persons.form.placeholders.personnelNumber": "Enter personnel number",
  "persons.form.placeholders.postalCode": "Enter postal code",
  "persons.form.placeholders.privateMobile": "Enter private mobile number",
  "persons.form.placeholders.socialSecurityNumber": "Enter social security number",
  "persons.form.placeholders.street": "Enter street",
  "persons.form.placeholders.vacationDays": "Enter vacation days",
  "persons.form.validation.cityMaxLength": "City must be 100 characters or less",
  "persons.form.validation.countryMaxLength": "Country must be 100 characters or less",
  "persons.form.validation.personnelNumberMaxLength": "Personnel number must be 50 characters or less",
  "persons.form.validation.postalCodeMaxLength": "Postal code must be 20 characters or less",
  "persons.form.validation.socialSecurityNumberMaxLength": "Social security number must be 50 characters or less",
  "persons.form.validation.streetMaxLength": "Street must be 255 characters or less",
  "persons.list.actions.create": "Create person",
  "persons.list.actions.deletePerson": "Persoon verwijderen",
  "persons.list.actions.edit": "Edit",
  "persons.list.actions.saving": "Saving…",
  "persons.list.actions.sendInvite": "Send invite",
  "persons.list.allTypes": "Alle typen",
  "persons.list.columns.email": "Email",
  "persons.list.columns.name": "Name",
  "persons.list.columns.personnelNumber": "Personeelsnr.",
  "persons.list.columns.type": "Type",
  "persons.list.description": "Browse and manage persons in the selected organization.",
  "persons.list.details.loading": "Loading person…",
  "persons.list.details.sections.account": "Account",
  "persons.list.details.sections.address": "Address",
  "persons.list.details.sections.administration": "Administration",
  "persons.list.details.sections.email": "Email",
  "persons.list.details.sections.meta": "Metadata",
  "persons.list.details.sections.socialSecurityReports": "Social security notifications",
  "persons.list.details.sections.socialSecurityReportsEmpty": "No social security notifications available.",
  "persons.list.fields.accountStatus": "Account status",
  "persons.list.fields.city": "City",
  "persons.list.fields.country": "Country",
  "persons.list.fields.mobile": "Mobile",
  "persons.list.fields.personnelNumber": "Personnel number",
  "persons.list.fields.postalCode": "Postal code",
  "persons.list.fields.privateEmail": "Email (private)",
  "persons.list.fields.privateMobile": "Private mobile",
  "persons.list.fields.socialSecurityNumber": "Social security number",
  "persons.list.fields.street": "Street",
  "persons.list.fields.vacationDays": "Vacation days",
  "persons.list.form.createTitle": "Create person",
  "persons.list.form.editTitle": "Edit person",
  "persons.list.form.loading": "Loading person…",
  "persons.list.form.placeholders.city": "Voer de plaats in",
  "persons.list.form.placeholders.country": "Voer het land in",
  "persons.list.form.placeholders.employmentRelationship": "Voer de werknemersgroep in",
  "persons.list.form.placeholders.employmentScopePercent": "bijv. 100",
  "persons.list.form.placeholders.personnelNumber": "Voer het personeelsnummer in",
  "persons.list.form.placeholders.postalCode": "Voer de postcode in",
  "persons.list.form.placeholders.privateMobile": "Voer het privé-mobielnummer in",
  "persons.list.form.placeholders.socialSecurityNumber": "Voer het sofinummer in",
  "persons.list.form.placeholders.street": "Voer de straat in",
  "persons.list.form.placeholders.vacationDays": "Voer de vakantiedagen in",
  "persons.list.invite.sent": "Invitation sent to {{email}}.",
  "persons.list.noOrganization.description": "Select an organization in the context switcher to view persons.",
  "persons.list.noOrganization.title": "No organization selected",
  "persons.list.placeholderDescription": "Select a person from the table to view details in the drawer.",
  "persons.list.placeholderTitle": "Persons",
  "persons.list.search": "Zoeken",
  "persons.list.searchPlaceholder": "Naam, deel ervan of personeelsnummer",
  "persons.list.status.invited": "Invited (pending)",
  "persons.list.status.linked": "Linked to user account",
  "persons.list.tabs.details": "Details",
  "persons.list.tabs.employments": "Dienstverbanden",
  "persons.list.tabs.settings": "Settings",
  "persons.list.tabs.skills": "Vaardigheden",
  "persons.list.unlink.action": "Unlink account",
  "persons.list.unlink.confirmDescription": "This person will no longer be linked to the user account. The user account itself will not be deleted.",
  "persons.list.unlink.confirmTitle": "Unlink user account?",
  "persons.list.unlink.loading": "Unlinking…",
  "persons.list.unlink.success": "Person unlinked from user account.",
  "persons.profile.assignments.empty.description": "You are linked to this organization but not assigned to a position yet. An administrator needs to place you in the organigram to grant access.",
  "persons.profile.assignments.empty.title": "Not yet placed in the organigram",
  "persons.profile.assignments.noRoles": "No roles",
  "persons.profile.assignments.primary": "Primary",
  "persons.profile.assignments.rolesLabel": "Roles",
  "persons.profile.fields.account": "Account",
  "persons.profile.fields.company": "Company",
  "persons.profile.fields.createdAt": "Created at",
  "persons.profile.fields.email": "Email",
  "persons.profile.fields.personId": "Person ID",
  "persons.profile.fields.phone": "Phone",
  "persons.profile.fields.type": "Type",
  "persons.profile.loading": "Loading profile…",
  "persons.profile.noOrganization.description": "Select an organization in the context switcher to view your profile.",
  "persons.profile.noOrganization.title": "No organization selected",
  "persons.profile.noPerson.description": "No person is linked to your user account in this organization.",
  "persons.profile.noPerson.title": "No person in this organization",
  "persons.profile.sections.assignments": "Positions & roles",
  "persons.profile.sections.contact": "Contact",
  "persons.profile.sections.meta": "Metadata",
  "persons.profile.title": "Profile",
  "processing.closing.alreadyClosed": "Deze periode is al afgesloten.",
  "processing.closing.blockedByContracts": "Afsluiten niet mogelijk: {{count}} van {{seen}} contracten hebben een fout. De rest is opgeslagen.",
  "processing.closing.close": "{{period}} afsluiten",
  "processing.closing.gap.DEPENDENT": "overgeslagen omdat een eerdere dag mislukte",
  "processing.closing.gap.FAILED": "fout bij verwerking",
  "processing.closing.gap.INPUT_CHANGED": "stempels gewijzigd na verwerking",
  "processing.closing.gap.NEVER_COMPUTED": "nooit verwerkt",
  "processing.closing.gap.NO_RULE_SET": "geen regelset toegewezen",
  "processing.closing.gap.NO_WORK_SCHEDULE": "geen tijdmodel",
  "processing.closing.gap.RUN_FAILED": "de run is als geheel mislukt",
  "processing.closing.hint": "Een afsluiting vergrendelt de periode en legt de saldi vast. Heropenen verwijdert niets: de afsluiting blijft zichtbaar als teruggenomen.",
  "processing.closing.incomplete": "Niet volledig verwerkt: {{count}} hiaat/hiaten – de afsluiting blijft geblokkeerd.",
  "processing.closing.moreGaps": "… en nog {{count}}",
  "processing.closing.needsCompletedRun": "Een afsluiting vereist een succesvol afgeronde verwerking.",
  "processing.closing.reopen": "Heropenen",
  "processing.closing.snapshots": "{{count}} saldi vastgelegd",
  "processing.closing.title": "Afsluiting",
  "processing.log.covers": "{{days}} dagen · {{contracts}} dienstverbanden",
  "processing.log.days.date": "Datum",
  "processing.log.days.employment": "Dienstverband",
  "processing.log.days.entries": "Boekingen",
  "processing.log.days.none": "Deze verwerking was voor geen enkele dag verantwoordelijk.",
  "processing.log.days.reason": "Toelichting",
  "processing.log.days.segments": "Segmenten",
  "processing.log.days.status": "Status",
  "processing.log.days.statuses.FAILED": "Fout",
  "processing.log.days.statuses.SKIPPED": "Overgeslagen",
  "processing.log.days.statuses.SUCCEEDED": "Geslaagd",
  "processing.log.days.title": "Dagen en dienstverbanden",
  "processing.log.days.warnings": "Meldingen",
  "processing.log.newRun": "Nieuwe verwerking",
  "processing.log.run": "Verwerking",
  "processing.log.subtitle": "Verwerkingsstatus tot op persoon en dag, in plaats van één ongedifferentieerde totale fout.",
  "processing.log.totals.dependent": "Afhankelijke vervolgdagen",
  "processing.log.totals.failed": "Dagen met een fout",
  "processing.log.totals.skipped": "Overgeslagen dagen",
  "processing.log.totals.succeeded": "Geslaagde dagen",
  "processing.messages.ABSENCE_ALREADY_BOOKED": "Afwezigheid was al geboekt",
  "processing.messages.ABSENCE_ENTERED_BY_HAND": "Afwezigheid met de hand ingevoerd",
  "processing.messages.ABSENCE_NO_TIME_TYPE": "Afwezigheid zonder tijdsoort",
  "processing.messages.ABSENCE_SPAN_WITHDRAWN": "Afwezigheidsperiode ingetrokken",
  "processing.messages.ABSENCE_UNKNOWN_TIME_TYPE": "Afwezigheid met onbekende tijdsoort",
  "processing.messages.ABSENCE_VALUED": "Afwezigheid gewaardeerd",
  "processing.messages.ABSENCE_WITHOUT_SEGMENT": "Afwezigheid zonder segment",
  "processing.messages.ACCOUNT_ALREADY_AT_VALUE": "De rekening staat al op deze waarde",
  "processing.messages.AMBIGUOUS_SEGMENT_START": "Dubbelzinnig segmentbegin",
  "processing.messages.BOOKING_NO_ACCOUNT": "Boeking zonder rekening",
  "processing.messages.BOOKING_NO_AMOUNT": "Boeking zonder bedrag",
  "processing.messages.BOOKING_NO_VALUATION": "Boeking zonder waardering",
  "processing.messages.BREAK_RULE_NO_THRESHOLD": "Pauzeregel zonder drempel",
  "processing.messages.BREAK_SHORTFALL_DEDUCTED": "Ontbrekende pauze afgetrokken",
  "processing.messages.BREAK_SHORTFALL_UNCOVERED": "Ontbrekende pauze niet gedekt",
  "processing.messages.CATCH_UP_DAYS_ADDED": "Eerdere dagen ingehaald",
  "processing.messages.CATCH_UP_LIMIT_REACHED": "Inhaalgrens bereikt; de resterende dagen blijven open",
  "processing.messages.CLOSURE_AFTER_FAILED_DAY": "Afsluitfase niet uitgevoerd — de periode heeft een gat",
  "processing.messages.CLOSURE_DAY_LOCKED": "Dag vergrendeld door afsluiting",
  "processing.messages.CONDITION_NOT_EVALUABLE": "Voorwaarde niet te evalueren",
  "processing.messages.CORRECTION_NO_SEGMENT": "Correctie vond geen segment",
  "processing.messages.CORRECTION_NO_TIME": "Correctie zonder geldige tijd",
  "processing.messages.CORRECTION_NOT_IMPLEMENTED": "Correctie niet geïmplementeerd",
  "processing.messages.DAILY_DURATION_LIMIT_REACHED": "Dagmaximum bereikt",
  "processing.messages.DAILY_LIMIT_NOT_READABLE": "Dagmaximum niet leesbaar",
  "processing.messages.DAY_FAILED": "Dag mislukt",
  "processing.messages.DAY_LOCKED": "Dag vergrendeld",
  "processing.messages.DAY_PLAN_MISSING": "Geen dagprogramma",
  "processing.messages.DEPENDENT_DAY_SKIPPED": "Overgeslagen — een eerdere dag van dit dienstverband is mislukt",
  "processing.messages.DEPENDENT_DAYS_ADDED": "Afhankelijke latere dagen herberekend",
  "processing.messages.EARLIER_ENTRIES_REVERSED": "Boekingen uit een eerdere run gestorneerd",
  "processing.messages.EARLIEST_START_APPLIED": "Vroegste begin toegepast",
  "processing.messages.EMPLOYMENT_FAILED": "Dienstverband mislukt",
  "processing.messages.NO_SEGMENTATION_RULES": "Geen segmentatieregels",
  "processing.messages.OPEN_SEGMENT_AFTER_CORRECTIONS": "Open segment na de correcties",
  "processing.messages.OVERLAPPING_SEGMENT_START": "Overlappend segmentbegin",
  "processing.messages.RULE_MESSAGE": "Melding uit het regelwerk",
  "processing.messages.RULE_SET_INHERITED": "Regelwerk geërfd van een bovenliggende eenheid",
  "processing.messages.RULE_SET_NOT_COMPILED": "Regelwerk niet gecompileerd",
  "processing.messages.SECTION_RULE_NO_ACCOUNT": "Sectieregel zonder rekening",
  "processing.messages.SECTION_RULE_WRONG_PHASE": "Sectieregel in de verkeerde fase",
  "processing.messages.SEGMENT_CREATED": "Segment door het regelwerk aangemaakt",
  "processing.messages.SEGMENT_NO_END": "Segment zonder einde",
  "processing.messages.SEGMENT_NO_START": "Segment zonder begin",
  "processing.messages.SEGMENT_NO_TIME_TYPE": "Segment zonder tijdsoort",
  "processing.messages.SEGMENT_NOT_CLOSED": "Segment niet gesloten",
  "processing.messages.SEGMENT_NOT_FORWARD": "Segment loopt niet vooruit",
  "processing.messages.SEGMENT_UNKNOWN_TIME_TYPE": "Segment met onbekende tijdsoort",
  "processing.messages.STATEMENT_NOT_IMPLEMENTED": "Instructie nog niet geïmplementeerd",
  "processing.messages.TIMEZONE_FALLBACK": "Vervangende tijdzone gebruikt",
  "processing.messages.TRANSFER_INCOMPLETE": "Overboeking onvolledig",
  "processing.messages.UNKNOWN_ACCOUNT": "Onbekende rekening",
  "processing.messages.UNKNOWN_TIME_TYPE": "Onbekende tijdsoort",
  "processing.messages.UNUSED_BOOKING": "Boeking niet gebruikt",
  "processing.messages.VARIABLE_NOT_RESOLVED": "Variabele niet opgelost",
  "processing.overview.covers": "Over deze eenheid en alles eronder — {{count}} eenheden. Een verwerking dekt alleen de gekozen eenheid.",
  "processing.overview.errors.loadFailed": "De kerncijfers konden niet worden geladen.",
  "processing.overview.lastProcessed": "Laatst verwerkt",
  "processing.overview.lastProcessedHint": "de laatste verwerking die klaar is",
  "processing.overview.never": "nog nooit",
  "processing.overview.openDays": "Openstaande dagen",
  "processing.overview.openDaysHint": "tot gisteren, door geen enkele schone verwerking bereikt",
  "processing.overview.retroactive": "Correcties met terugwerkende kracht",
  "processing.overview.retroactiveHint": "berekende dagen waarvan de boeking later kwam",
  "processing.overview.withErrors": "Dienstverbanden met een fout",
  "processing.overview.withErrorsHint": "in hun meest recente verwerking",
  "processing.result.bookings": "Boekingen",
  "processing.result.contract.figures": "{{from}} – {{to}}: {{succeeded}} dagen berekend, {{failed}} met fouten, {{skipped}} overgeslagen, {{entries}} boekingen",
  "processing.result.contract.statuses.FAILED": "mislukt",
  "processing.result.contract.statuses.PARTIAL": "gedeeltelijk geslaagd",
  "processing.result.contract.statuses.SKIPPED": "overgeslagen",
  "processing.result.contract.statuses.SUCCEEDED": "geslaagd",
  "processing.result.dayTotal": "Dagtotaal",
  "processing.result.employment": "Dienstverband",
  "processing.result.empty": "Deze verwerking leverde geen segmenten, boekingen of meldingen op.",
  "processing.result.errorCount": "{{count}} fouten",
  "processing.result.errors.loadFailed": "Het resultaat kon niet worden geladen.",
  "processing.result.governance.inheritedFrom": "· geërfd van {{unit}}",
  "processing.result.governance.skipped.NO_RULE_SET": "Geen regelset voor dit tijdmodel — niets berekend",
  "processing.result.governance.skipped.NO_WORK_SCHEDULE": "Geen tijdmodel ingesteld — niets berekend",
  "processing.result.governance.skippedCount": "{{count}} contracten zonder regelset",
  "processing.result.governance.title": "Toegepaste regelsets",
  "processing.result.governance.version": "Versie {{version}}",
  "processing.result.governance.workSchedule": "Tijdmodel",
  "processing.result.messageGroups.perContract": "Afzonderlijke contracten",
  "processing.result.messageGroups.runLevel": "Betreft de hele verwerking",
  "processing.result.messages": "Meldingen",
  "processing.result.noBookings": "Deze verwerking heeft niets geboekt.",
  "processing.result.open": "open",
  "processing.result.phase": "Fase {{phase}}",
  "processing.result.segments": "Segmenten",
  "processing.result.summary.contracts": "{{clean}} van {{seen}} contracten zijn doorgelopen.",
  "processing.result.summary.runLevel": "Fouten die de hele verwerking betreffen: {{count}}",
  "processing.result.summary.withErrors": "Waarvan {{count}} met een fout.",
  "processing.result.superseded": "vervangen",
  "processing.result.warningCount": "{{count}} waarschuwingen",
  "processing.run.configure": "Verwerking instellen",
  "processing.run.contracts": "{{count}} dienstverbanden",
  "processing.run.covers": "Omvat {{count}} dienstverbanden.",
  "processing.run.coversOne": "Omvat één dienstverband.",
  "processing.run.employment": "Dienstverband",
  "processing.run.errors.listFailed": "De verwerkingen konden niet worden geladen.",
  "processing.run.errors.noEmployment": "Deze eenheid biedt geen dienstverband om te kiezen.",
  "processing.run.errors.noEmployments": "Deze eenheid heeft geen dienstverbanden — een verwerking zou niets berekenen.",
  "processing.run.errors.periodOrder": "Het einde mag niet voor het begin liggen.",
  "processing.run.errors.startFailed": "De verwerking kon niet worden gestart.",
  "processing.run.flow.BOOKINGS.detail": "Rekeningmutaties. Boekingen van eerdere verwerkingen voor dezelfde dagen worden gestorneerd.",
  "processing.run.flow.BOOKINGS.title": "Boekingen",
  "processing.run.flow.CALCULATION.detail": "Pauzes, norm en werkelijk, per dag.",
  "processing.run.flow.CALCULATION.title": "Berekening",
  "processing.run.flow.CLOSURES.detail": "Draait bij elke verwerking; het regelwerk bepaalt met “on run” wat hier gebeurt.",
  "processing.run.flow.CLOSURES.title": "Afsluitingen",
  "processing.run.flow.CORRECTIONS.detail": "Regels verbeteren segmenten; de vervangen versie blijft leesbaar.",
  "processing.run.flow.CORRECTIONS.title": "Correcties",
  "processing.run.flow.SEGMENTATION.detail": "Boekingen en afwezigheden worden tijdsegmenten.",
  "processing.run.flow.SEGMENTATION.title": "Segmentatie",
  "processing.run.flow.synchronous": "De verwerking hangt aan deze aanroep, niet aan een achtergronddienst: de pagina wacht tot ze klaar is en opent dan het log.",
  "processing.run.flow.title": "Verloop van een verwerking",
  "processing.run.from": "Van",
  "processing.run.hints.recomputes": "Alle dagen van–tot worden opnieuw berekend, ongeacht eerdere verwerkingen. Hun boekingen voor deze dagen worden gestorneerd.",
  "processing.run.hints.runType": "Het verwerkingstype bepaalt alleen welke “on run”-regels van het regelwerk vuren. Elke dag van de periode wordt hoe dan ook berekend.",
  "processing.run.isolation": "Foutisolatie: een foute dag houdt noch de andere dienstverbanden noch de dagen ervoor tegen. De volgende dagen van hetzelfde dienstverband worden overgeslagen — ze rekenen op die dag verder.",
  "processing.run.lastRun.contracts": "{{seen}} dienstverbanden, {{clean}} zonder fouten, {{errors}} met fouten",
  "processing.run.lastRun.title": "{{name}}:",
  "processing.run.none": "Deze eenheid heeft nog geen verwerkingen.",
  "processing.run.noUnits": "Er zijn geen organisatie-eenheden beschikbaar.",
  "processing.run.open": "Bekijken",
  "processing.run.openLog": "Verwerkingslog openen",
  "processing.run.outcome.FAILED": "Fout",
  "processing.run.outcome.PARTIAL": "Gedeeltelijk",
  "processing.run.outcome.RUNNING": "Bezig",
  "processing.run.outcome.SUCCEEDED": "Geslaagd",
  "processing.run.preview.catchUp": ", plus {{count}} dagen die de verwerking uit zichzelf inhaalt",
  "processing.run.preview.catchUpDays": "+{{count}} voor de periode",
  "processing.run.preview.check": "Voorbeeld bekijken",
  "processing.run.preview.days": "{{count}} dagen",
  "processing.run.preview.dependentDays": "+{{count}} erna (afhankelijk)",
  "processing.run.preview.empty": "Deze eenheid heeft geen dienstverband.",
  "processing.run.preview.errors.failed": "Het voorbeeld kon niet worden geladen.",
  "processing.run.preview.inherited": "· geërfd van {{unit}}",
  "processing.run.preview.locked": ", waarvan {{count}} vergrendeld door een afsluiting",
  "processing.run.preview.noDays": "geen dag in de periode",
  "processing.run.preview.outsideWindow": "de periode ligt buiten dit dienstverband",
  "processing.run.preview.period": " Periode: {{days}} dagen",
  "processing.run.preview.scheduleChanges": "het tijdmodel wisselt in de periode — het getoonde regelwerk geldt voor de eerste dag",
  "processing.run.preview.summary": "{{compute}} van {{total}} dienstverbanden zouden worden berekend, {{skip}} overgeslagen.",
  "processing.run.preview.title": "Wat deze verwerking zou aanraken",
  "processing.run.preview.version": "versie {{version}}",
  "processing.run.recent": "Recente verwerkingen",
  "processing.run.scope": "Omvang",
  "processing.run.scopes.EMPLOYMENT": "Eén dienstverband",
  "processing.run.scopes.UNIT": "Hele organisatie-eenheid",
  "processing.run.selectHint": "Kies hierboven een verwerking om het resultaat te zien.",
  "processing.run.start": "Verwerking starten",
  "processing.run.subtitle": "Een periode opnieuw laten berekenen en eerdere verwerkingen openen.",
  "processing.run.table.number": "Verw.-nr.",
  "processing.run.table.outcome": "Resultaat",
  "processing.run.table.period": "Periode",
  "processing.run.table.runType": "Type",
  "processing.run.table.scope": "Omvang",
  "processing.run.table.startedAt": "Gestart",
  "processing.run.to": "Tot",
  "processing.run.type": "Soort verwerking",
  "processing.run.types.CLOSING": "Afsluiting",
  "processing.run.types.DAILY": "Dagelijks",
  "processing.run.types.PERIOD": "Periode",
  "processing.run.types.RECALCULATION": "Herberekening",
  "processing.run.unit": "Organisatie-eenheid",
  "settings.accounts.actions.create": "Create user",
  "settings.accounts.actions.edit": "Edit",
  "settings.accounts.actions.saving": "Saving…",
  "settings.accounts.columns.email": "Email",
  "settings.accounts.columns.name": "Name",
  "settings.accounts.description": "Manage user accounts and role assignments.",
  "settings.accounts.details.assignedRoles": "Assigned roles",
  "settings.accounts.details.fullName": "Full name",
  "settings.accounts.details.loading": "Loading user…",
  "settings.accounts.details.noRolesAssigned": "No roles assigned",
  "settings.accounts.details.sections.access": "Access",
  "settings.accounts.details.sections.userInfo": "User information",
  "settings.accounts.details.status": "Status",
  "settings.accounts.details.statusApproved": "Approved",
  "settings.accounts.details.statusPending": "Pending approval",
  "settings.accounts.details.userId": "User ID",
  "settings.accounts.form.createTitle": "Create user",
  "settings.accounts.form.editTitle": "Edit user",
  "settings.accounts.form.fields.email": "Email",
  "settings.accounts.form.fields.isApproved": "Approved for access",
  "settings.accounts.form.fields.isApprovedHint": "Allow this account to sign in to Workforce.",
  "settings.accounts.form.fields.name": "Full name",
  "settings.accounts.form.fields.role": "Role",
  "settings.accounts.form.fields.roleHint": "Select the role for this user.",
  "settings.accounts.form.fields.roleValue.admin": "Admin",
  "settings.accounts.form.fields.roleValue.superAdmin": "Super Admin",
  "settings.accounts.form.fields.roleValue.user": "User",
  "settings.accounts.form.loading": "Loading user…",
  "settings.accounts.form.roles.noRolesAvailable": "No roles available",
  "settings.accounts.form.roles.selected": "selected",
  "settings.accounts.form.roles.title": "Roles",
  "settings.accounts.form.validation.nameMaxLength": "Name is too long",
  "settings.accounts.form.validation.nameRequired": "Name is required",
  "settings.accounts.list.placeholderDescription": "Select a user from the table to view details in the drawer.",
  "settings.accounts.list.placeholderTitle": "User accounts",
  "settings.accounts.title": "Users",
  "settings.organizations.actions.create": "Create organization",
  "settings.organizations.actions.edit": "Edit",
  "settings.organizations.actions.saving": "Saving…",
  "settings.organizations.columns.createdAt": "Created at",
  "settings.organizations.columns.name": "Name",
  "settings.organizations.description": "Manage organizations (power user feature).",
  "settings.organizations.details.createdAt": "Created at",
  "settings.organizations.details.loading": "Loading organization…",
  "settings.organizations.details.name": "Name",
  "settings.organizations.details.organizationId": "Organization ID",
  "settings.organizations.details.sections.info": "Organization information",
  "settings.organizations.form.createTitle": "Create organization",
  "settings.organizations.form.editTitle": "Edit organization",
  "settings.organizations.form.fields.name": "Name",
  "settings.organizations.form.fields.owners": "Owners / Admins",
  "settings.organizations.form.fields.ownersEmpty": "No persons found.",
  "settings.organizations.form.fields.ownersHint": "Selected persons are added as admins of this organization (Owner position on the root unit).",
  "settings.organizations.form.fields.ownersSearch": "Search persons…",
  "settings.organizations.form.loading": "Loading organization…",
  "settings.organizations.form.validation.nameMaxLength": "Name is too long",
  "settings.organizations.form.validation.nameRequired": "Name is required",
  "settings.organizations.list.placeholderDescription": "Select an organization from the table to view details in the drawer.",
  "settings.organizations.list.placeholderTitle": "Organizations",
  "settings.organizations.title": "Organizations",
  "settings.payScales.actions.create": "Cao aanmaken",
  "settings.payScales.actions.edit": "Bewerken",
  "settings.payScales.actions.saving": "Opslaan…",
  "settings.payScales.columns.code": "Code",
  "settings.payScales.columns.name": "Naam",
  "settings.payScales.columns.validFrom": "Geldig vanaf",
  "settings.payScales.columns.validTo": "Geldig tot",
  "settings.payScales.columns.weeklyWorkHours": "Uren per week",
  "settings.payScales.description": "Beheer collectieve arbeidsovereenkomsten met hun salarisgroepen en -niveaus.",
  "settings.payScales.details.code": "Code",
  "settings.payScales.details.createdAt": "Aangemaakt op",
  "settings.payScales.details.dailyWorkHours": "Dagelijkse arbeidstijd",
  "settings.payScales.details.loading": "Cao wordt geladen…",
  "settings.payScales.details.monthlyWorkHours": "Maandelijkse arbeidstijd",
  "settings.payScales.details.name": "Naam",
  "settings.payScales.details.sections.apprenticeIncome": "Leerlingloon",
  "settings.payScales.details.sections.info": "Cao-informatie",
  "settings.payScales.details.sections.salaryTables": "Minimumlonen",
  "settings.payScales.details.table.amount": "Bedrag",
  "settings.payScales.details.table.emptyCell": "—",
  "settings.payScales.details.table.level": "Niveau",
  "settings.payScales.details.tablesEmpty": "Voor deze cao zijn nog geen salarisgroepen of niveaus geconfigureerd.",
  "settings.payScales.details.tablesLoading": "Salaristabellen worden geladen…",
  "settings.payScales.details.validFrom": "Geldig vanaf",
  "settings.payScales.details.validTo": "Geldig tot",
  "settings.payScales.details.weeklyWorkHours": "Wekelijkse arbeidstijd",
  "settings.payScales.form.createTitle": "Cao aanmaken",
  "settings.payScales.form.editTitle": "Cao bewerken",
  "settings.payScales.form.fields.code": "Code",
  "settings.payScales.form.fields.dailyWorkHours": "Dagelijkse arbeidstijd",
  "settings.payScales.form.fields.monthlyWorkHours": "Maandelijkse arbeidstijd",
  "settings.payScales.form.fields.name": "Naam",
  "settings.payScales.form.fields.validFrom": "Geldig vanaf",
  "settings.payScales.form.fields.validTo": "Geldig tot",
  "settings.payScales.form.fields.weeklyWorkHours": "Wekelijkse arbeidstijd",
  "settings.payScales.form.loading": "Cao wordt geladen…",
  "settings.payScales.form.validation.codeMaxLength": "Code is te lang",
  "settings.payScales.form.validation.codeRequired": "Code is verplicht",
  "settings.payScales.form.validation.nameMaxLength": "Naam is te lang",
  "settings.payScales.form.validation.nameRequired": "Naam is verplicht",
  "settings.payScales.form.validation.validFromRequired": "'Geldig vanaf' is verplicht",
  "settings.payScales.list.placeholderDescription": "Selecteer een cao in de tabel om de details te bekijken.",
  "settings.payScales.list.placeholderTitle": "Collectieve arbeidsovereenkomsten",
  "settings.payScales.title": "Collectieve arbeidsovereenkomsten",
  "settings.profile.fields.company": "Company",
  "settings.profile.fields.createdAt": "Created at",
  "settings.profile.fields.email": "Email",
  "settings.profile.fields.personId": "Person ID",
  "settings.profile.fields.phone": "Phone",
  "settings.profile.fields.type": "Type",
  "settings.profile.loading": "Loading profile…",
  "settings.profile.noOrganization.description": "Select an organization in the context switcher to view your profile in that organization.",
  "settings.profile.noOrganization.title": "No organization selected",
  "settings.profile.noPerson.description": "No person is linked to your user account in this organization.",
  "settings.profile.noPerson.title": "No person in this organization",
  "settings.profile.sections.contact": "Contact",
  "settings.profile.sections.meta": "Metadata",
  "settings.profile.title": "Profile",
  "settings.roles.actions.cancel": "Annuleren",
  "settings.roles.actions.create": "Maken",
  "settings.roles.actions.edit": "Bewerken",
  "settings.roles.actions.save": "Opslaan",
  "settings.roles.actions.saving": "Opslaan…",
  "settings.roles.columns.description": "Description",
  "settings.roles.columns.name": "Name",
  "settings.roles.description": "Manage organization roles and permissions",
  "settings.roles.form.createTitle": "Rol aanmaken",
  "settings.roles.form.editTitle": "Rol bewerken",
  "settings.roles.form.fields.description": "Beschrijving",
  "settings.roles.form.fields.name": "Naam",
  "settings.roles.form.loading": "Rol laden…",
  "settings.roles.form.section.info": "Rolinformatie",
  "settings.roles.form.validation.descriptionMaxLength": "Beschrijving is te lang",
  "settings.roles.form.validation.nameMaxLength": "Naam is te lang",
  "settings.roles.form.validation.nameRequired": "Naam is verplicht",
  "settings.roles.list.placeholderDescription": "Selecteer een rol uit de tabel om details in het deelvenster weer te geven.",
  "settings.roles.list.placeholderTitle": "Rollen",
  "settings.roles.permissionMatrix": "Permission Matrix",
  "settings.roles.permissionMatrixDescription": "View the permissions granted to this role across different scopes and entities",
  "settings.roles.title": "Roles",
  "settings.textCatalog.actions.backToCatalog": "Terug naar catalogusitems",
  "settings.textCatalog.actions.create": "Create entry",
  "settings.textCatalog.actions.edit": "Edit",
  "settings.textCatalog.actions.manageLanguages": "Manage languages",
  "settings.textCatalog.actions.manageTypes": "Catalogustypen beheren",
  "settings.textCatalog.actions.saving": "Saving…",
  "settings.textCatalog.columns.catalogKey": "Key",
  "settings.textCatalog.columns.catalogType": "Type",
  "settings.textCatalog.columns.name": "Label",
  "settings.textCatalog.columns.scope": "Bereik",
  "settings.textCatalog.description": "Beheer dynamische catalogusitems en hun vertalingen.",
  "settings.textCatalog.details.loading": "Loading catalog entry…",
  "settings.textCatalog.details.sections.info": "Entry details",
  "settings.textCatalog.filters.catalogType": "Catalog type",
  "settings.textCatalog.filters.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.form.createTitle": "Create catalog entry",
  "settings.textCatalog.form.editTitle": "Edit catalog entry",
  "settings.textCatalog.form.fields.catalogKey": "Key",
  "settings.textCatalog.form.fields.catalogKeyPlaceholder": "female",
  "settings.textCatalog.form.fields.catalogType": "Type",
  "settings.textCatalog.form.fields.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.form.fields.countryCode": "Land",
  "settings.textCatalog.form.fields.countryCodePlaceholder": "Kies een land",
  "settings.textCatalog.form.fields.noActiveLanguages": "Geen actieve talen geconfigureerd.",
  "settings.textCatalog.form.fields.organization": "Organisatie",
  "settings.textCatalog.form.fields.organizationPlaceholder": "Kies een organisatie",
  "settings.textCatalog.form.fields.organizationUnit": "Organisatie-eenheid",
  "settings.textCatalog.form.fields.organizationUnitPlaceholder": "Kies een organisatie-eenheid",
  "settings.textCatalog.form.fields.scope": "Bereik",
  "settings.textCatalog.form.fields.scopePlaceholder": "Kies een bereik",
  "settings.textCatalog.form.fields.translationPlaceholder": "Translation for {{language}}",
  "settings.textCatalog.form.fields.translations": "Translations",
  "settings.textCatalog.form.loading": "Loading catalog entry…",
  "settings.textCatalog.form.scope.country": "Land",
  "settings.textCatalog.form.scope.global": "Globaal",
  "settings.textCatalog.form.scope.organizationUnit": "Organisatie-eenheid",
  "settings.textCatalog.form.section.identity": "Identity",
  "settings.textCatalog.form.section.scope": "Bereik",
  "settings.textCatalog.form.validation.catalogKeyMaxLength": "Key is too long",
  "settings.textCatalog.form.validation.catalogKeyPattern": "Key may only contain letters, numbers, underscores, and dashes",
  "settings.textCatalog.form.validation.catalogKeyRequired": "Key is required",
  "settings.textCatalog.form.validation.catalogTypeMaxLength": "Type is too long",
  "settings.textCatalog.form.validation.catalogTypePattern": "Type must be uppercase letters, numbers, and underscores",
  "settings.textCatalog.form.validation.catalogTypeRequired": "Type is required",
  "settings.textCatalog.form.validation.scopeRequired": "Bereik is verplicht",
  "settings.textCatalog.languages.actions.create": "Create language",
  "settings.textCatalog.languages.actions.edit": "Edit",
  "settings.textCatalog.languages.actions.saving": "Saving…",
  "settings.textCatalog.languages.columns.code": "Code",
  "settings.textCatalog.languages.columns.isActive": "Active",
  "settings.textCatalog.languages.columns.name": "Name",
  "settings.textCatalog.languages.columns.sortOrder": "Sort order",
  "settings.textCatalog.languages.description": "Manage available languages for catalog translations.",
  "settings.textCatalog.languages.details.loading": "Loading language…",
  "settings.textCatalog.languages.details.sections.info": "Language details",
  "settings.textCatalog.languages.form.createTitle": "Create language",
  "settings.textCatalog.languages.form.editTitle": "Edit language",
  "settings.textCatalog.languages.form.fields.code": "Code",
  "settings.textCatalog.languages.form.fields.codePlaceholder": "en",
  "settings.textCatalog.languages.form.fields.isActive": "Active",
  "settings.textCatalog.languages.form.fields.name": "Name",
  "settings.textCatalog.languages.form.fields.namePlaceholder": "English",
  "settings.textCatalog.languages.form.fields.sortOrder": "Sort order",
  "settings.textCatalog.languages.form.loading": "Loading language…",
  "settings.textCatalog.languages.form.section.info": "Language",
  "settings.textCatalog.languages.form.validation.codeMaxLength": "Code is too long",
  "settings.textCatalog.languages.form.validation.codeMinLength": "Code must be at least 2 characters",
  "settings.textCatalog.languages.form.validation.codePattern": "Code may only contain letters, numbers, underscores, and dashes",
  "settings.textCatalog.languages.form.validation.codeRequired": "Code is required",
  "settings.textCatalog.languages.form.validation.nameMaxLength": "Name is too long",
  "settings.textCatalog.languages.form.validation.nameRequired": "Name is required",
  "settings.textCatalog.languages.list.placeholderDescription": "Select a language from the table to view details in the drawer.",
  "settings.textCatalog.languages.list.placeholderTitle": "Languages",
  "settings.textCatalog.languages.title": "Languages",
  "settings.textCatalog.list.placeholderDescription": "Select a catalog entry from the table to view details in the drawer.",
  "settings.textCatalog.list.placeholderTitle": "Catalog entries",
  "settings.textCatalog.title": "Tekstcatalogus",
  "settings.textCatalog.types.actions.create": "Catalogustype aanmaken",
  "settings.textCatalog.types.actions.edit": "Bewerken",
  "settings.textCatalog.types.actions.saving": "Bezig met opslaan…",
  "settings.textCatalog.types.columns.catalogType": "Type",
  "settings.textCatalog.types.columns.permissionAction": "Permissie-actie",
  "settings.textCatalog.types.columns.permissionEntity": "Permissie-entiteit",
  "settings.textCatalog.types.description": "Catalogustypen registreren en instellen welke rechten nodig zijn om ze binnen een organisatie-eenheid te lezen.",
  "settings.textCatalog.types.details.loading": "Catalogustype wordt geladen…",
  "settings.textCatalog.types.details.sections.info": "Details van het type",
  "settings.textCatalog.types.form.createTitle": "Catalogustype aanmaken",
  "settings.textCatalog.types.form.editTitle": "Catalogustype bewerken",
  "settings.textCatalog.types.form.fields.catalogType": "Typecode",
  "settings.textCatalog.types.form.fields.catalogTypePlaceholder": "GENDER",
  "settings.textCatalog.types.form.fields.organizations": "Organisaties",
  "settings.textCatalog.types.form.fields.organizationsPlaceholder": "Kies organisaties",
  "settings.textCatalog.types.form.fields.permissionAction": "Rechtenactie",
  "settings.textCatalog.types.form.fields.permissionActionPlaceholder": "Kies een actie",
  "settings.textCatalog.types.form.fields.permissionEntity": "Rechtenbereik",
  "settings.textCatalog.types.form.fields.permissionEntityPlaceholder": "Kies een bereik",
  "settings.textCatalog.types.form.fields.permissionNone": "Geen",
  "settings.textCatalog.types.form.fields.scopeMode": "Bereik",
  "settings.textCatalog.types.form.fields.scopeModePlaceholder": "Kies een bereik",
  "settings.textCatalog.types.form.loading": "Catalogustype wordt geladen…",
  "settings.textCatalog.types.form.permissionHint": "Indien ingesteld moet de aanvrager dit recht op de gevraagde organisatie-eenheid hebben om niet-globale items te lezen.",
  "settings.textCatalog.types.form.section.identity": "Identificatie",
  "settings.textCatalog.types.form.section.organizations": "Toegang tot organisaties",
  "settings.textCatalog.types.form.section.permission": "Recht binnen de eenheid",
  "settings.textCatalog.types.form.validation.catalogTypeMaxLength": "Type is te lang",
  "settings.textCatalog.types.form.validation.catalogTypePattern": "Type mag alleen hoofdletters, cijfers en underscores bevatten",
  "settings.textCatalog.types.form.validation.catalogTypeRequired": "Type is verplicht",
  "settings.textCatalog.types.form.validation.scopeModeRequired": "Bereik is verplicht",
  "settings.textCatalog.types.list.placeholderDescription": "Kies een catalogustype in de tabel om de details te zien.",
  "settings.textCatalog.types.list.placeholderTitle": "Catalogustypen",
  "settings.textCatalog.types.scopeMode.global": "Globaal",
  "settings.textCatalog.types.scopeMode.organization": "Organisatie",
  "settings.textCatalog.types.title": "Catalogustypen",
  "settings.textCatalog.values.no": "No",
  "settings.textCatalog.values.yes": "Yes",
  "skill.entity.group.persons": "Personen",
  "skill.entity.skill": "Vaardigheden",
  "skills.actions.create": "+ Vaardigheid",
  "skills.actions.edit": "Bewerken",
  "skills.actions.saving": "Opslaan …",
  "skills.columns.code": "Code",
  "skills.columns.description": "Omschrijving",
  "skills.columns.name": "Naam",
  "skills.description": "De vaardigheden van deze organisatie. Het niveau wordt bij de persoon ingesteld.",
  "skills.details.code": "Code",
  "skills.details.description": "Omschrijving",
  "skills.details.name": "Naam",
  "skills.details.sections.info": "Vaardigheid",
  "skills.form.createTitle": "Nieuwe vaardigheid",
  "skills.form.editTitle": "Vaardigheid bewerken",
  "skills.form.fields.code": "Code",
  "skills.form.fields.codeHint": "Kort en uniek. Eisen en imports verwijzen er later naar.",
  "skills.form.fields.codePlaceholder": "bijv. HEFTRUCK",
  "skills.form.fields.description": "Omschrijving (optioneel)",
  "skills.form.fields.name": "Naam",
  "skills.form.fields.namePlaceholder": "bijv. Heftruckcertificaat",
  "skills.form.loading": "Laden …",
  "skills.form.validation.codeMaxLength": "De code mag hoogstens 50 tekens lang zijn.",
  "skills.form.validation.codeRequired": "Geef een code op.",
  "skills.form.validation.descriptionMaxLength": "De omschrijving mag hoogstens 1000 tekens lang zijn.",
  "skills.form.validation.nameMaxLength": "De naam mag hoogstens 255 tekens lang zijn.",
  "skills.form.validation.nameRequired": "Geef een naam op.",
  "skills.level.ASSISTED": "Onder begeleiding",
  "skills.level.EXPERIENCED": "Ervaren",
  "skills.level.INDEPENDENT": "Zelfstandig",
  "skills.level.INSTRUCTOR": "Kan anderen opleiden",
  "skills.level.LEARNING": "In opleiding",
  "skills.list.placeholderDescription": "Klik op een rij om de vaardigheid te bekijken.",
  "skills.list.placeholderTitle": "Geen vaardigheid gekozen",
  "skills.person.add.level": "Niveau",
  "skills.person.add.skill": "Vaardigheid",
  "skills.person.add.skillPlaceholder": "Kies een vaardigheid",
  "skills.person.add.submit": "Toevoegen",
  "skills.person.catalogueError": "De vaardighedencatalogus kon niet worden geladen.",
  "skills.person.description": "Wat deze persoon kan en op welk niveau. De vaardigheden zelf beheer je onder Personen → Vaardigheden.",
  "skills.person.empty": "Voor deze persoon is nog geen vaardigheid vastgelegd.",
  "skills.person.loadError": "De vaardigheden van deze persoon konden niet worden geladen.",
  "skills.person.loading": "Laden …",
  "skills.person.noOrganization": "Deze persoon hoort bij geen enkele organisatie. Vaardigheden worden per organisatie beheerd.",
  "skills.person.nothingLeft": "Alle vaardigheden uit de catalogus zijn al vastgelegd.",
  "skills.person.remove.confirm": "“{{name}}” wordt bij deze persoon verwijderd. De vaardigheid blijft in de catalogus.",
  "skills.person.title": "Vaardigheden",
  "skills.requirements.add.hint": "De keuze vereist haar meteen met “{{level}}”. Het niveau pas je daarna in haar rij aan.",
  "skills.requirements.add.skill": "Vaardigheid vereisen",
  "skills.requirements.add.skillPlaceholder": "Kies een vaardigheid",
  "skills.requirements.atLeast": "minstens",
  "skills.requirements.catalogueError": "De vaardighedencatalogus kon niet worden geladen.",
  "skills.requirements.empty": "Er is nog geen vaardigheid vereist.",
  "skills.requirements.loadError": "De vereiste vaardigheden konden niet worden geladen.",
  "skills.requirements.loading": "Laden …",
  "skills.requirements.nothingLeft": "Alle vaardigheden uit de catalogus zijn al vereist.",
  "skills.requirements.positionDescription": "Wat deze functie vereist. Het niveau is een minimum — wie erboven zit, voldoet ook.",
  "skills.requirements.remove.confirm": "“{{name}}” wordt hier niet meer vereist. De vaardigheid blijft in de catalogus.",
  "skills.requirements.stationDescription": "Wat dit station vereist. Het niveau is een minimum — wie erboven zit, voldoet ook.",
  "skills.requirements.title": "Vereiste vaardigheden",
  "skills.title": "Vaardigheden",
  "table.columns.moveDown": "{{column}} omlaag",
  "table.columns.moveUp": "{{column}} omhoog",
  "table.columns.restoreDefault": "Standaard",
  "table.columns.save": "Opslaan",
  "table.columns.showAll": "Alles tonen",
  "table.columns.title": "Kolommen",
  "textCatalog.select.empty": "Geen catalogusitems beschikbaar",
  "textCatalog.select.error": "Catalogusitems laden mislukt",
  "textCatalog.select.loading": "Catalogusitems laden…",
  "timeAccounts.correction.account": "Rekening",
  "timeAccounts.correction.accountPlaceholder": "Rekening kiezen",
  "timeAccounts.correction.amount": "Bedrag",
  "timeAccounts.correction.amountDecimal": "bijv. -1 of 0,5",
  "timeAccounts.correction.amountMinutes": "bijv. -0:30 of +1:15",
  "timeAccounts.correction.amountUnreadable": "Dit bedrag is niet leesbaar of nul.",
  "timeAccounts.correction.book": "Boeken",
  "timeAccounts.correction.booked": "Correctie geboekt. De volgende verwerking berekent de dagen erna opnieuw.",
  "timeAccounts.correction.bookTitle": "Correctie boeken",
  "timeAccounts.correction.date": "Datum",
  "timeAccounts.correction.errors.accountNotCorrectable": "Deze rekening is op deze dag niet open voor handmatige boekingen.",
  "timeAccounts.correction.errors.alreadyReversed": "Deze correctie is al teruggeboekt.",
  "timeAccounts.correction.errors.belowFloor": "Het saldo zou onder het toegestane minimum van de rekening komen.",
  "timeAccounts.correction.errors.closed": "Deze dag valt in een afgesloten periode.",
  "timeAccounts.correction.errors.failed": "Boeken mislukt. Probeer het opnieuw.",
  "timeAccounts.correction.errors.forbidden": "Hiervoor ontbreekt de machtiging.",
  "timeAccounts.correction.errors.notACorrection": "Alleen een handmatig geboekte correctie kan hier worden teruggeboekt.",
  "timeAccounts.correction.nextRunHint": "De dagen erna worden bij de volgende verwerking opnieuw berekend.",
  "timeAccounts.correction.noAccounts": "Op deze dag is geen rekening open voor handmatige boekingen.",
  "timeAccounts.correction.note": "Reden",
  "timeAccounts.correction.reverse": "Terugboeken",
  "timeAccounts.correction.reversed": "teruggeboekt",
  "timeAccounts.correction.reversedToast": "Correctie teruggeboekt. De volgende verwerking berekent de dagen erna opnieuw.",
  "timeAccounts.correction.reverseNote": "Reden voor het terugboeken",
  "timeAccounts.correction.reverseTitle": "Correctie terugboeken",
  "timeAccounts.correction.saving": "Bezig met boeken…",
  "timeAccounts.employment": "Dienstverband",
  "timeAccounts.errors.loadFailed": "De saldi konden niet worden geladen.",
  "timeAccounts.fromEntries": "uit {{count}} boekingen",
  "timeAccounts.grid.accountView": "Rekeningen",
  "timeAccounts.grid.accountViews.balance": "Stand aan het einde van de dag",
  "timeAccounts.grid.accountViews.movement": "Mutatie van de dag",
  "timeAccounts.grid.allTimeTypes": "Alle tijdsoorten",
  "timeAccounts.grid.break": "Pauze",
  "timeAccounts.grid.columns": "Kolommen",
  "timeAccounts.grid.date": "Datum",
  "timeAccounts.grid.dayCount": "{{shown}} van {{total}} dagen",
  "timeAccounts.grid.deduction": "Aftrek",
  "timeAccounts.grid.filters.all": "Alle dagen",
  "timeAccounts.grid.filters.booked": "Alleen dagen met boekingen",
  "timeAccounts.grid.filters.deviating": "Alleen afwijkingen van de norm",
  "timeAccounts.grid.kind": "Tijdsoort",
  "timeAccounts.grid.loadFailed": "Het maandjournaal kon niet worden geladen.",
  "timeAccounts.grid.note": "Opmerking",
  "timeAccounts.grid.overtime": "Overuren",
  "timeAccounts.grid.show": "Tonen",
  "timeAccounts.grid.spans": "Berekende boekingen",
  "timeAccounts.grid.target": "Normtijd",
  "timeAccounts.grid.timeType": "Tijdsoort",
  "timeAccounts.grid.timeTypes": "Tijdsoorten",
  "timeAccounts.grid.toggleDay": "Dag open- of dichtklappen",
  "timeAccounts.grid.weekday": "Dag",
  "timeAccounts.grid.worked": "Gewerkt",
  "timeAccounts.header.nextMonth": "Volgende maand",
  "timeAccounts.header.nextYear": "Volgend jaar",
  "timeAccounts.header.noPerson": "Geen dienstverband gekozen",
  "timeAccounts.header.period": "Periode",
  "timeAccounts.header.personnelNumber": "Pers.nr. {{number}}",
  "timeAccounts.header.previousMonth": "Vorige maand",
  "timeAccounts.header.previousYear": "Vorig jaar",
  "timeAccounts.header.workSchedule": "Tijdmodel",
  "timeAccounts.journal.block": "blok {{id}}",
  "timeAccounts.journal.byHand": "handmatig · {{name}}",
  "timeAccounts.journal.operations.closing": "Afsluiting",
  "timeAccounts.journal.operations.initialize": "Op waarde gezet",
  "timeAccounts.journal.operations.manual": "Correctie",
  "timeAccounts.journal.operations.reversal": "Terugboeking",
  "timeAccounts.journal.operations.transfer": "Overboeking",
  "timeAccounts.journal.operations.valuation": "Dagwaardering",
  "timeAccounts.journal.reversed": "teruggeboekt",
  "timeAccounts.journal.reversedBy": "teruggeboekt door {{id}}",
  "timeAccounts.journal.reverses": "boekt {{id}} terug",
  "timeAccounts.journal.run": "Verwerking #{{number}}",
  "timeAccounts.journal.runFailed": "verwerking mislukt",
  "timeAccounts.journal.transferGroup": "overboekingsgroep",
  "timeAccounts.journal.valuation": "waarde {{value}}",
  "timeAccounts.ledgerHint": "Opgeteld uit het boekingsjournaal tot het einde van de maand, niet uit een opgeslagen momentopname.",
  "timeAccounts.noBalances": "Tot het einde van de maand is voor dit dienstverband niets geboekt.",
  "timeAccounts.noEmployments": "Deze eenheid heeft geen dienstverbanden.",
  "timeAccounts.organizationUnit": "Organisatie-eenheid",
  "timeAccounts.summary.account": "Rekening",
  "timeAccounts.summary.amount": "Bedrag",
  "timeAccounts.summary.asOf": "Stand op {{date}}",
  "timeAccounts.summary.balance": "Saldo",
  "timeAccounts.summary.balanceAfter": "Saldo na boeking",
  "timeAccounts.summary.balances": "Saldi aan het einde van de maand",
  "timeAccounts.summary.corrections": "Bijzondere boekingen en correcties",
  "timeAccounts.summary.correctionsHint": "Alles wat niet de waardering van de dag zelf is — met de hand geboekt, uit een afsluiting of gestorneerd.",
  "timeAccounts.summary.monthChange": "Mutatie deze maand",
  "timeAccounts.summary.noCorrections": "Deze maand is er niets met de hand geboekt.",
  "timeAccounts.summary.origin": "Herkomst",
  "timeAccounts.summary.origins.CLOSING": "Afsluiting",
  "timeAccounts.summary.origins.INITIALIZE": "Op waarde gezet",
  "timeAccounts.summary.origins.MANUAL": "Met de hand",
  "timeAccounts.summary.origins.REVERSAL": "Storno",
  "timeAccounts.summary.showHiddenAccounts": "Ook verborgen rekeningen tonen ({{count}})",
  "timeAccounts.summary.unit": "Eenheid",
  "timeAccounts.transfers.from": "Van",
  "timeAccounts.transfers.hint": "Wat regels of personen van de ene rekening naar de andere hebben geboekt. Een uitbetaling is een overboeking naar een uitbetalingsrekening.",
  "timeAccounts.transfers.none": "Geen geldige overboekingen in deze periode.",
  "timeAccounts.transfers.rule": "Regel",
  "timeAccounts.transfers.showReversed": "{{count}} door een latere verwerking teruggeboekte tonen",
  "timeAccounts.transfers.standing": "geldig",
  "timeAccounts.transfers.status": "Status",
  "timeAccounts.transfers.title": "Overboekingen",
  "timeAccounts.transfers.to": "Naar",
  "timeAccounts.unit.counter": "",
  "timeAccounts.unit.days": "dagen",
  "timeAccounts.unit.minutes": "u",
  "timeAccounts.unit.number": "",
  "timeManagement.accounts.actions.create": "Rekening aanmaken",
  "timeManagement.accounts.delete.confirm": "Wilt u deze rekening echt verwijderen?",
  "timeManagement.accounts.displayFormat.DAYS": "Dagen",
  "timeManagement.accounts.displayFormat.DECIMAL_HOURS": "Decimale uren",
  "timeManagement.accounts.displayFormat.HH_MM": "Uren:minuten",
  "timeManagement.accounts.errors.loadFailed": "Rekeningen konden niet worden geladen.",
  "timeManagement.accounts.form.createTitle": "Nieuwe rekening",
  "timeManagement.accounts.form.editTitle": "Rekening bewerken",
  "timeManagement.accounts.form.fields.accountKind": "Rekeningsoort",
  "timeManagement.accounts.form.fields.allowsManualBooking": "Handmatig boeken toegestaan",
  "timeManagement.accounts.form.fields.allowsNegativeBalance": "Negatief saldo toegestaan",
  "timeManagement.accounts.form.fields.code": "Code",
  "timeManagement.accounts.form.fields.codePlaceholder": "bijv. OVERUREN_50",
  "timeManagement.accounts.form.fields.displayFormat": "Weergaveformaat",
  "timeManagement.accounts.form.fields.displayFormatHelp": "Alleen weergave — verandert niet hoe het saldo wordt opgeslagen.",
  "timeManagement.accounts.form.fields.displayFormatNone": "Geen formaat",
  "timeManagement.accounts.form.fields.internal": "Intern",
  "timeManagement.accounts.form.fields.name": "Omschrijving",
  "timeManagement.accounts.form.fields.negativeLimit": "Ondergrens (optioneel)",
  "timeManagement.accounts.form.fields.shownInSpecialBookings": "Tonen onder „Bijzondere boekingen”",
  "timeManagement.accounts.form.fields.valueType": "Waardetype",
  "timeManagement.accounts.form.hints.internal": "Alleen zichtbaar voor gebruikers met de machtiging „Interne rekeningen zien”.",
  "timeManagement.accounts.form.overrideTitle": "Rekening overschrijven",
  "timeManagement.accounts.form.validation.codeMaxLength": "Code is te lang.",
  "timeManagement.accounts.form.validation.codeRequired": "Code is verplicht.",
  "timeManagement.accounts.form.validation.nameMaxLength": "Omschrijving is te lang.",
  "timeManagement.accounts.form.validation.nameRequired": "Omschrijving is verplicht.",
  "timeManagement.accounts.form.validation.validFromRequired": "Geldig vanaf is verplicht.",
  "timeManagement.accounts.kind.COUNTER": "Teller",
  "timeManagement.accounts.kind.ENTITLEMENT": "Aanspraak",
  "timeManagement.accounts.kind.TIME": "Tijdrekening",
  "timeManagement.accounts.list.empty": "Nog geen rekeningen aanwezig.",
  "timeManagement.accounts.list.hiddenFromSpecialBookings": "niet onder bijzondere boekingen",
  "timeManagement.accounts.list.internal": "intern",
  "timeManagement.accounts.list.manualBooking": "handmatig boekbaar",
  "timeManagement.accounts.list.noNegative": "geen negatief saldo",
  "timeManagement.accounts.valueType.COUNTER": "Teller",
  "timeManagement.accounts.valueType.DAYS": "Dagen",
  "timeManagement.accounts.valueType.MINUTES": "Minuten",
  "timeManagement.accounts.valueType.NUMBER": "Getal",
  "timeManagement.bookingTypes.actions.create": "Boekingssoort aanmaken",
  "timeManagement.bookingTypes.delete.confirm": "Wilt u deze boekingssoort echt verwijderen?",
  "timeManagement.bookingTypes.directionHint.END": "Einde",
  "timeManagement.bookingTypes.directionHint.NEUTRAL": "Neutraal",
  "timeManagement.bookingTypes.directionHint.START": "Begin",
  "timeManagement.bookingTypes.errors.loadFailed": "Boekingssoorten konden niet worden geladen.",
  "timeManagement.bookingTypes.form.createTitle": "Nieuwe boekingssoort",
  "timeManagement.bookingTypes.form.editTitle": "Boekingssoort bewerken",
  "timeManagement.bookingTypes.form.fields.code": "Code",
  "timeManagement.bookingTypes.form.fields.codePlaceholder": "bijv. KOMEN",
  "timeManagement.bookingTypes.form.fields.directionHint": "Richting (alleen weergave)",
  "timeManagement.bookingTypes.form.fields.directionHintHelp": "Alleen een weergavehint — de daadwerkelijke koppeling van begin en einde bepaalt het regelwerk.",
  "timeManagement.bookingTypes.form.fields.directionHintNone": "Geen hint",
  "timeManagement.bookingTypes.form.fields.isRealBooking": "Echte boeking (geen systeemmarkering)",
  "timeManagement.bookingTypes.form.fields.name": "Omschrijving",
  "timeManagement.bookingTypes.form.overrideTitle": "Boekingssoort overschrijven",
  "timeManagement.bookingTypes.form.validation.codeMaxLength": "Code is te lang.",
  "timeManagement.bookingTypes.form.validation.codeRequired": "Code is verplicht.",
  "timeManagement.bookingTypes.form.validation.nameMaxLength": "Omschrijving is te lang.",
  "timeManagement.bookingTypes.form.validation.nameRequired": "Omschrijving is verplicht.",
  "timeManagement.bookingTypes.form.validation.validFromRequired": "Geldig vanaf is verplicht.",
  "timeManagement.bookingTypes.list.empty": "Nog geen boekingssoorten aanwezig.",
  "timeManagement.bookingTypes.list.systemMarker": "systeemmarkering",
  "timeManagement.common.inheritedFrom": "geërfd van {{unit}}",
  "timeManagement.common.overridden": "overschreven",
  "timeManagement.common.override": "Hier overschrijven",
  "timeManagement.common.restore": "Lokale versie verwijderen (weer erven)",
  "timeManagement.common.saving": "Opslaan …",
  "timeManagement.common.validFrom": "Geldig vanaf",
  "timeManagement.common.validTo": "Geldig tot",
  "timeManagement.common.validUntil": "tot {{date}}",
  "timeManagement.dayPrograms.actions.create": "Nieuw dagprogramma",
  "timeManagement.dayPrograms.delete.confirm": "Dit dagprogramma verwijderen?",
  "timeManagement.dayPrograms.errors.loadFailed": "De dagprogramma's konden niet worden geladen.",
  "timeManagement.dayPrograms.form.coreTime.add": "Kerntijd toevoegen",
  "timeManagement.dayPrograms.form.coreTime.empty": "Voor deze dag is geen kerntijd vastgelegd.",
  "timeManagement.dayPrograms.form.coreTime.endsNextDay": "eindigt de volgende dag",
  "timeManagement.dayPrograms.form.coreTime.from": "van",
  "timeManagement.dayPrograms.form.coreTime.hint": "Het tijdvak waarin aanwezigheid wordt verwacht. Geldt voor elke weekdag die dit dagprogramma gebruikt.",
  "timeManagement.dayPrograms.form.coreTime.problem.incomplete": "Geef begin en einde van de kerntijd op.",
  "timeManagement.dayPrograms.form.coreTime.problem.notForward": "De kerntijd moet na het begin eindigen.",
  "timeManagement.dayPrograms.form.coreTime.problem.overlap": "Twee kerntijden mogen dezelfde minuut niet beslaan. De ene mag beginnen waar de andere eindigt.",
  "timeManagement.dayPrograms.form.coreTime.remove": "Kerntijd verwijderen",
  "timeManagement.dayPrograms.form.coreTime.title": "Kerntijd",
  "timeManagement.dayPrograms.form.coreTime.to": "tot",
  "timeManagement.dayPrograms.form.createTitle": "Nieuw dagprogramma",
  "timeManagement.dayPrograms.form.editTitle": "Dagprogramma bewerken",
  "timeManagement.dayPrograms.form.fields.code": "Code",
  "timeManagement.dayPrograms.form.fields.codePlaceholder": "NORMAL",
  "timeManagement.dayPrograms.form.fields.name": "Naam",
  "timeManagement.dayPrograms.form.fields.targetMinutes": "Normminuten",
  "timeManagement.dayPrograms.form.fields.targetMinutesHint": "Leeg laten om de intervallen op te tellen.",
  "timeManagement.dayPrograms.form.fields.validFrom": "Geldig vanaf",
  "timeManagement.dayPrograms.form.fields.validTo": "Geldig tot",
  "timeManagement.dayPrograms.form.intervals.add": "Interval toevoegen",
  "timeManagement.dayPrograms.form.intervals.chooseKind": "Maak een keuze…",
  "timeManagement.dayPrograms.form.intervals.empty": "Nog geen intervallen. Zonder deze heeft de dag geen gepland verloop.",
  "timeManagement.dayPrograms.form.intervals.end": "Tot",
  "timeManagement.dayPrograms.form.intervals.endsNextDay": "Eindigt de volgende dag",
  "timeManagement.dayPrograms.form.intervals.errors.endBeforeStart": "Het einde ligt niet na het begin. Vink voor een nachtdienst “eindigt de volgende dag” aan.",
  "timeManagement.dayPrograms.form.intervals.errors.overlaps": "Dit interval overlapt een eerder interval. Twee intervallen van hetzelfde dagprogramma mogen dezelfde minuut niet twee keer beslaan — maar het ene mag wel eindigen waar het volgende begint.",
  "timeManagement.dayPrograms.form.intervals.kind": "Soort",
  "timeManagement.dayPrograms.form.intervals.moveDown": "Omlaag",
  "timeManagement.dayPrograms.form.intervals.moveUp": "Omhoog",
  "timeManagement.dayPrograms.form.intervals.remove": "Verwijderen",
  "timeManagement.dayPrograms.form.intervals.spans": "duurt {{minutes}} min",
  "timeManagement.dayPrograms.form.intervals.start": "Van",
  "timeManagement.dayPrograms.form.intervals.targetMinutes": "Telt als (min)",
  "timeManagement.dayPrograms.form.intervals.title": "Intervallen",
  "timeManagement.dayPrograms.form.overrideTitle": "Dagprogramma overschrijven",
  "timeManagement.dayPrograms.form.saving": "Bezig met opslaan…",
  "timeManagement.dayPrograms.form.validation.codeMaxLength": "De code mag maximaal 50 tekens hebben.",
  "timeManagement.dayPrograms.form.validation.codeRequired": "Voer een code in.",
  "timeManagement.dayPrograms.form.validation.nameMaxLength": "De naam mag maximaal 255 tekens hebben.",
  "timeManagement.dayPrograms.form.validation.nameRequired": "Voer een naam in.",
  "timeManagement.dayPrograms.form.validation.validFromRequired": "Voer het begin van de geldigheid in.",
  "timeManagement.dayPrograms.list.empty": "Deze eenheid heeft nog geen dagprogramma's.",
  "timeManagement.dayPrograms.list.target": "Norm {{minutes}} min",
  "timeManagement.dayPrograms.list.targetFromIntervals": "Norm uit de intervallen",
  "timeManagement.publicHolidays.actions.create": "Feestdag toevoegen",
  "timeManagement.publicHolidays.calendar.empty": "Dit jaar valt er geen feestdag op deze eenheid.",
  "timeManagement.publicHolidays.calendar.nextYear": "Volgend jaar",
  "timeManagement.publicHolidays.calendar.previousYear": "Vorig jaar",
  "timeManagement.publicHolidays.calendar.title": "Kalender {{year}}",
  "timeManagement.publicHolidays.delete.confirm": "Deze feestdag echt verwijderen?",
  "timeManagement.publicHolidays.errors.loadFailed": "De feestdagen konden niet worden geladen.",
  "timeManagement.publicHolidays.form.createTitle": "Feestdag toevoegen",
  "timeManagement.publicHolidays.form.editTitle": "Feestdag bewerken",
  "timeManagement.publicHolidays.form.fields.code": "Code",
  "timeManagement.publicHolidays.form.fields.countries": "Geldt in deze landen",
  "timeManagement.publicHolidays.form.fields.dayOfMonth": "Dag",
  "timeManagement.publicHolidays.form.fields.kind": "Hoe de datum wordt bepaald",
  "timeManagement.publicHolidays.form.fields.monthOfYear": "Maand",
  "timeManagement.publicHolidays.form.fields.name": "Naam",
  "timeManagement.publicHolidays.form.fields.offsetDays": "Dagen vanaf eerste paasdag",
  "timeManagement.publicHolidays.form.fields.singleDate": "Datum",
  "timeManagement.publicHolidays.form.fields.validFrom": "Geldig vanaf",
  "timeManagement.publicHolidays.form.fields.validTo": "Geldig tot",
  "timeManagement.publicHolidays.form.hints.countries": "Alleen landen die in het organigram voorkomen. Halve dag betekent de helft van de norm, zonder ligging.",
  "timeManagement.publicHolidays.form.hints.noCountries": "In het organigram is nog geen land ingesteld. Stel er een in bij het bedrijf of de wortel.",
  "timeManagement.publicHolidays.form.hints.offsetDays": "Negatief loopt vóór Pasen: Goede Vrijdag −2, tweede paasdag 1, Sacramentsdag 60.",
  "timeManagement.publicHolidays.form.hints.singleDate": "De ene datum waarop deze feestdag valt. Hij keert niet terug.",
  "timeManagement.publicHolidays.form.hints.validity": "Wanneer de feestdag bestaat, niet wanneer hij valt. Leeg betekent onbeperkt.",
  "timeManagement.publicHolidays.form.overrideTitle": "Feestdag overschrijven",
  "timeManagement.publicHolidays.form.validation.codeMaxLength": "De code mag hoogstens 50 tekens bevatten.",
  "timeManagement.publicHolidays.form.validation.codeRequired": "Een code is verplicht.",
  "timeManagement.publicHolidays.form.validation.countryNone": "Kies minstens één land — anders geldt de feestdag nergens.",
  "timeManagement.publicHolidays.form.validation.dateNeverOccurs": "Deze dag bestaat in geen enkel jaar.",
  "timeManagement.publicHolidays.form.validation.dayOutOfRange": "De dag moet tussen 1 en 31 liggen.",
  "timeManagement.publicHolidays.form.validation.easterNeedsOffset": "Een vanaf Pasen berekende feestdag heeft een verschuiving nodig.",
  "timeManagement.publicHolidays.form.validation.easterTakesNoDate": "Een vanaf Pasen berekende feestdag heeft geen vaste datum.",
  "timeManagement.publicHolidays.form.validation.fixedNeedsDate": "Een feestdag op een vaste datum heeft maand en dag nodig.",
  "timeManagement.publicHolidays.form.validation.fixedTakesNoOffset": "Een feestdag op een vaste datum heeft geen paasverschuiving.",
  "timeManagement.publicHolidays.form.validation.monthOutOfRange": "De maand moet tussen 1 en 12 liggen.",
  "timeManagement.publicHolidays.form.validation.nameMaxLength": "De naam mag hoogstens 255 tekens bevatten.",
  "timeManagement.publicHolidays.form.validation.nameRequired": "Een naam is verplicht.",
  "timeManagement.publicHolidays.form.validation.offsetOutOfRange": "De verschuiving is te groot voor een beweegbare feestdag.",
  "timeManagement.publicHolidays.form.validation.recurringTakesNoSingleDate": "Een terugkerende feestdag draagt geen eenmalige datum.",
  "timeManagement.publicHolidays.form.validation.singleDateMalformed": "Dat moet een echte dag zijn, als JJJJ-MM-DD.",
  "timeManagement.publicHolidays.form.validation.singleNeedsDate": "Een eenmalige feestdag heeft zijn datum nodig.",
  "timeManagement.publicHolidays.form.validation.singleTakesNoRule": "Een eenmalige feestdag draagt noch maand en dag noch een paasverschuiving.",
  "timeManagement.publicHolidays.form.validation.validFromRequired": "Een begin van de geldigheid is verplicht.",
  "timeManagement.publicHolidays.kinds.EASTER_OFFSET": "Vanaf Pasen berekend",
  "timeManagement.publicHolidays.kinds.FIXED": "Vaste datum",
  "timeManagement.publicHolidays.kinds.SINGLE_DATE": "Eenmalig",
  "timeManagement.publicHolidays.list.definitionsTitle": "Feestdagen",
  "timeManagement.publicHolidays.list.empty": "Voor deze eenheid is nog geen feestdag vastgelegd.",
  "timeManagement.publicHolidays.observances.FULL": "Heel",
  "timeManagement.publicHolidays.observances.HALF": "Half",
  "timeManagement.publicHolidays.tabs.calendar": "Kalender",
  "timeManagement.publicHolidays.tabs.list": "Feestdagen",
  "timeManagement.timeTypes.actions.create": "Tijdsoort aanmaken",
  "timeManagement.timeTypes.delete.confirm": "Wilt u deze tijdsoort echt verwijderen?",
  "timeManagement.timeTypes.errors.loadFailed": "Tijdsoorten konden niet worden geladen.",
  "timeManagement.timeTypes.form.createTitle": "Nieuwe tijdsoort",
  "timeManagement.timeTypes.form.editTitle": "Tijdsoort bewerken",
  "timeManagement.timeTypes.form.fields.category": "Categorie",
  "timeManagement.timeTypes.form.fields.categoryPlaceholder": "Selecteer …",
  "timeManagement.timeTypes.form.fields.code": "Code",
  "timeManagement.timeTypes.form.fields.displayOrder": "Weergavevolgorde (optioneel)",
  "timeManagement.timeTypes.form.fields.evaluationPriority": "Voorrang",
  "timeManagement.timeTypes.form.fields.evaluationPriorityHint": "Bij overlap op dezelfde dag wint het hoogste getal. 0 betekent geen voorrang.",
  "timeManagement.timeTypes.form.fields.name": "Omschrijving",
  "timeManagement.timeTypes.form.fields.workTimeCreditMode": "Toerekening aan doeltijd",
  "timeManagement.timeTypes.form.fields.workTimeCreditModeHint": "Hoe een segment van dit tijdtype meetelt voor de doeltijd.",
  "timeManagement.timeTypes.form.fields.workTimeCreditModePlaceholder": "Toerekeningswijze kiezen",
  "timeManagement.timeTypes.form.overrideTitle": "Tijdsoort overschrijven",
  "timeManagement.timeTypes.form.validation.categoryRequired": "Categorie is verplicht.",
  "timeManagement.timeTypes.form.validation.codeMaxLength": "Code is te lang.",
  "timeManagement.timeTypes.form.validation.codeRequired": "Code is verplicht.",
  "timeManagement.timeTypes.form.validation.creditModeRequired": "Toerekeningswijze is verplicht",
  "timeManagement.timeTypes.form.validation.nameMaxLength": "Omschrijving is te lang.",
  "timeManagement.timeTypes.form.validation.nameRequired": "Omschrijving is verplicht.",
  "timeManagement.timeTypes.form.validation.validFromRequired": "Geldig vanaf is verplicht.",
  "timeManagement.timeTypes.list.empty": "Nog geen tijdsoorten aanwezig.",
  "timeManagement.timeTypes.list.priority": "voorrang {{value}}",
  "timeManagement.workSchedules.actions.create": "Nieuw tijdmodel",
  "timeManagement.workSchedules.delete.confirm": "Dit tijdmodel verwijderen?",
  "timeManagement.workSchedules.errors.loadFailed": "De tijdmodellen konden niet worden geladen.",
  "timeManagement.workSchedules.form.coreTime.add": "+ Kerntijd",
  "timeManagement.workSchedules.form.coreTime.endsNextDay": "eindigt de volgende dag",
  "timeManagement.workSchedules.form.coreTime.from": "Kerntijd van",
  "timeManagement.workSchedules.form.coreTime.hint": "Optioneel per weekdag: de kerntijd waarin de persoon aanwezig hoort te zijn.",
  "timeManagement.workSchedules.form.coreTime.problems.incomplete": "Een kerntijd heeft een begin en een einde nodig.",
  "timeManagement.workSchedules.form.coreTime.problems.notForward": "Een kerntijd moet na het begin eindigen — vink \"eindigt de volgende dag\" aan voor een venster over middernacht.",
  "timeManagement.workSchedules.form.coreTime.problems.overlap": "Twee kerntijden van dezelfde dag overlappen. De ene mag precies eindigen waar de volgende begint.",
  "timeManagement.workSchedules.form.coreTime.remove": "Kerntijd verwijderen",
  "timeManagement.workSchedules.form.coreTime.to": "tot",
  "timeManagement.workSchedules.form.createTitle": "Nieuw tijdmodel",
  "timeManagement.workSchedules.form.editTitle": "Tijdmodel bewerken",
  "timeManagement.workSchedules.form.fields.code": "Code",
  "timeManagement.workSchedules.form.fields.codePlaceholder": "STANDARD",
  "timeManagement.workSchedules.form.fields.cycleWeeks": "Cyclus (weken)",
  "timeManagement.workSchedules.form.fields.cycleWeeksHint": "1 betekent elke week hetzelfde. Meer weken geven een roterend patroon.",
  "timeManagement.workSchedules.form.fields.name": "Naam",
  "timeManagement.workSchedules.form.fields.validFrom": "Geldig vanaf",
  "timeManagement.workSchedules.form.fields.validTo": "Geldig tot",
  "timeManagement.workSchedules.form.grid.dayOff": "— vrij —",
  "timeManagement.workSchedules.form.grid.dayProgramsFailed": "De dagprogramma’s konden niet worden geladen. Het weekpatroon kan pas worden ingevuld als dat lukt.",
  "timeManagement.workSchedules.form.grid.noDayPrograms": "Deze eenheid heeft nog geen dagprogramma, ook geen geërfd. Dagprogramma’s worden naar beneden geërfd, niet naar boven: een dagprogramma op een onderliggende eenheid telt hier niet. Maak er eerst een aan op deze of een bovenliggende eenheid.",
  "timeManagement.workSchedules.form.grid.title": "Weekpatroon",
  "timeManagement.workSchedules.form.grid.unreadableCycle": "Voer een cyclus tussen 1 en 52 weken in om het patroon te zien.",
  "timeManagement.workSchedules.form.grid.week": "Week {{week}}",
  "timeManagement.workSchedules.form.overrideTitle": "Tijdmodel overschrijven",
  "timeManagement.workSchedules.form.problems.coreTime": "Minstens één kerntijd is onvolledig of overlapt — zie de gemarkeerde weekdag.",
  "timeManagement.workSchedules.form.problems.cycleWeeks": "De cyclus moet een geheel getal tussen 1 en 52 weken zijn.",
  "timeManagement.workSchedules.form.problems.noDays": "Wijs aan minstens één weekdag een dagprogramma toe, anders plant dit model niets.",
  "timeManagement.workSchedules.form.saving": "Bezig met opslaan…",
  "timeManagement.workSchedules.form.validation.codeMaxLength": "De code mag maximaal 50 tekens hebben.",
  "timeManagement.workSchedules.form.validation.codeRequired": "Voer een code in.",
  "timeManagement.workSchedules.form.validation.nameMaxLength": "De naam mag maximaal 255 tekens hebben.",
  "timeManagement.workSchedules.form.validation.nameRequired": "Voer een naam in.",
  "timeManagement.workSchedules.form.validation.validFromRequired": "Voer het begin van de geldigheid in.",
  "timeManagement.workSchedules.list.cycle": "Cyclus van {{weeks}} week/weken",
  "timeManagement.workSchedules.list.empty": "Deze eenheid heeft nog geen tijdmodellen.",
  "timeManagement.workSchedules.weekday.1": "Maandag",
  "timeManagement.workSchedules.weekday.2": "Dinsdag",
  "timeManagement.workSchedules.weekday.3": "Woensdag",
  "timeManagement.workSchedules.weekday.4": "Donderdag",
  "timeManagement.workSchedules.weekday.5": "Vrijdag",
  "timeManagement.workSchedules.weekday.6": "Zaterdag",
  "timeManagement.workSchedules.weekday.7": "Zondag",
  "timeTracking.correct": "Corrigeren",
  "timeTracking.corrected": "gecorrigeerd",
  "timeTracking.countingStamps": "{{count}} tellende boekingen",
  "timeTracking.employment": "Dienstverband",
  "timeTracking.empty": "In deze periode is niets vastgelegd.",
  "timeTracking.errors.actionFailed": "De boeking kon niet worden opgeslagen.",
  "timeTracking.errors.loadFailed": "De boekingen konden niet worden geladen.",
  "timeTracking.errors.rangeOrder": "Het einde mag niet voor het begin liggen.",
  "timeTracking.form.abortCorrection": "Correctie afbreken",
  "timeTracking.form.bookingType": "Boekingssoort",
  "timeTracking.form.chooseBookingType": "Kies",
  "timeTracking.form.correcting": "Correctie van de boeking van {{time}}",
  "timeTracking.form.date": "Datum",
  "timeTracking.form.hint": "Er wordt niets overschreven: intrekken zet een status, corrigeren schrijft een nieuwe boeking die naar de oude verwijst. Een afgesloten dag wordt geweigerd.",
  "timeTracking.form.noBookingType": "Geen boekingssoort gevonden",
  "timeTracking.form.reason": "Reden",
  "timeTracking.form.record": "Vastleggen",
  "timeTracking.form.time": "Tijd",
  "timeTracking.form.title": "Boeking vastleggen",
  "timeTracking.from": "Van",
  "timeTracking.intervals.coming": "Komen",
  "timeTracking.intervals.duration": "Duur",
  "timeTracking.intervals.going": "Gaan",
  "timeTracking.intervals.stamped": "gestempeld {{time}}",
  "timeTracking.intervals.states.changed": "Berekening past niet bij de stempels – de volgende verwerking rekent opnieuw",
  "timeTracking.intervals.states.open": "nog niet verwerkt",
  "timeTracking.intervals.timeType": "Tijdsoort",
  "timeTracking.isCorrection": "correctie",
  "timeTracking.organizationUnit": "Organisatie-eenheid",
  "timeTracking.showWithdrawn": "Ingetrokken tonen",
  "timeTracking.to": "Tot",
  "timeTracking.view.intervals": "Intervallen",
  "timeTracking.view.label": "Weergave",
  "timeTracking.view.stamps": "Stempels",
  "timeTracking.withdraw": "Intrekken",
  "timeTracking.withdrawn": "ingetrokken"
}
